import React, { Component } from 'react';
import { instanceOf } from 'prop-types';
import {
  Modal, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, ModalBody, Row, Col,
  Popover, PopoverHeader, PopoverBody
} from 'reactstrap';
import '../../src/assets/js/menuCustom.js';
import Sidebar from "react-sidebar";
import {
  postQuery, pNotification, verifyEmail, commonAPI, LocationData
} from '../API/FetchCall';
import $ from 'jquery';
import {
  BASE_URL
} from '../constant';
import IdleTimer from 'react-idle-timer';
import { withCookies, Cookies } from 'react-cookie';
import swal from 'sweetalert';
import { Newlogin } from './new_login_reg';

const menusRightmenu= [{"category_name":"Pre-Schools","slug_term":"pre-schools","subdata":[{"category_name":"Montessori","slug_term":"montessori"},{"category_name":"Kindergarten","slug_term":"kindergarten"},{"category_name":"Play Group","slug_term":"play-group"},{"category_name":"Special Needs","slug_term":"special-needs"},{"category_name":"Day care or Creche","slug_term":"day-care-or-creche"}]},{"category_name":"Schools","slug_term":"schools","subdata":[{"category_name":"Private School","slug_term":"private-schools"},{"category_name":"Public School","slug_term":"public-schools"},{"category_name":"Boarding School","slug_term":"boarding-schools"},{"category_name":"International School","slug_term":"international-schools"},{"category_name":"Special Needs","slug_term":"school-special-needs"},{"category_name":"Alternative School","slug_term":"alternative-schools"},{"category_name":"Open School","slug_term":"open-schools"},{"category_name":"E-School","slug_term":"e-schools"}]},{"category_name":"Kids Play Areas","slug_term":"kids-play-area","subdata":[{"category_name":"Indoor","slug_term":"indoor"},{"category_name":"Outdoor","slug_term":"outdoor"}]},{"category_name":"After School Activity","slug_term":"after-school-activity","subdata":[{"category_name":"Sports","slug_term":"sports"},{"category_name":"Music","slug_term":"music"},{"category_name":"Dance and Theatre","slug_term":"dance-and-theatre"},{"category_name":"Creative Arts","slug_term":"creative-arts"},{"category_name":"Mind & Skills Enrichment","slug_term":"mind-and-skill-enrichment"},{"category_name":"Hobbies & Passion","slug_term":"hobbies-and-passion"}]},{"category_name":"Tuitions","slug_term":"tuitions","subdata":[{"category_name":"Maths","slug_term":"maths"},{"category_name":"Science/ EVS","slug_term":"science"},{"category_name":"Economics","slug_term":"economics"},{"category_name":"Business Studies","slug_term":"business-studies"},{"category_name":"Languages","slug_term":"languages"},{"category_name":"Social sciences","slug_term":"social-science"}]},{"category_name":"Learning Camps","slug_term":"learning-camps","subdata":[{"category_name":"Below 4 Years","slug_term":"below-4-years"},{"category_name":"5 - 7 Years","slug_term":"5-7-years"},{"category_name":"8 - 10 Years","slug_term":"8-10-years"},{"category_name":"11 - 12 Years","slug_term":"11-12-years"},{"category_name":"13 - 15 Years","slug_term":"13-15-years"},{"category_name":"BeWise Curated Learning camps","slug_term":"curated-learning-camps"},{"category_name":"Summer Camps","slug_term":"bewise-summer-camps"}]},{"category_name":"Community Support","slug_term":"community-support","subdata":[{"category_name":"Counselor","slug_term":"counselor"},{"category_name":"Articles and Blogs","slug_term":"articles-blogs"},{"category_name":"Growth Partnerships","slug_term":"growth-partnerships-for-you"}]},{"category_name":"Birthday & Events","slug_term":"birthday-event","subdata":[{"category_name":"Venues","slug_term":"venues"},{"category_name":"Bakery or Cake shops","slug_term":"bakery-or-cake-shops"},{"category_name":"Entertainers or MCs","slug_term":"entertainers-or-mcs"},{"category_name":"Party Planners","slug_term":"party-planners"},{"category_name":"Gifts & Supportives","slug_term":"gift-and-supportives"}]}];

class RightMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      showCityPop:false,
      isProfile: false,
      authe: false,
      isThirdMenu: false,
      filter_opt: false,
      menuList: menusRightmenu,
      current_menuList: [],
      active_category: '',
      active_sub_category: '',
      active_tsub_category: '',
      current_location: localStorage.getItem("current_location") ? localStorage.getItem("current_location") : 'bengaluru',
      screen_size: window.innerWidth
    };
    //this.getURLData(menusRightmenu);
    this.getMenu();
  }
  componentDidMount() {
    let auth = localStorage.getItem("logged_auth");
    let data_auth = (localStorage.getItem("myData"));
    if (data_auth) {
      let auth_data = JSON.parse(data_auth);
      let login_type_name = '';
      if (auth_data.login_type == 2) {
        login_type_name = 'Google';
      } else if (auth_data.login_type == 3) {
        login_type_name = 'Facebook';
      } else if (auth_data.login_type == 4) {
        login_type_name = 'LinkedIn';
      }
      this.setState({
        logged_name: auth_data.first_name + ' ' + auth_data.last_name,
        authe: true,
        user_id: auth_data.user_id,
        login_type: auth_data.login_type,
        login_type_name: login_type_name
      });
    }
    let qrystr = window.location.search;
    const urlParams = new URLSearchParams(qrystr);
    let tokenV = urlParams.get('token');
    let user_idV = urlParams.get('id');

    if (tokenV && user_idV) {
      let vdata = JSON.stringify({
        token: tokenV,
        user_id: user_idV
      })
      verifyEmail(vdata).then((response) => {
        let toastr = '';
        if (response.status == 1) {
          toastr = window.toastr.success;
          toastr(response.message, toastr, {
            positionClass: "toast-bottom-center",
            containerId: "toast-bottom-center"
          });
          window.location.href = '/';
        } else {
          let er = response.message
          toastr = window.toastr.error; //warning
          toastr(er, toastr, {
            positionClass: "toast-bottom-center",
            containerId: "toast-bottom-center"
          });
          window.location.href = '/';
        }
      });
    }
    let urlType = urlParams.get('type');
    if (urlType == 'linkedLogin') {
      let linkedState = urlParams.get('state');
      let authToken = urlParams.get('code');
      console.log('authTokenlinked', authToken);
      this.linkedinAuth(authToken, linkedState);
    }
  }
  getMenu = () => {
 
    commonAPI(JSON.stringify({ url: 'getMenu' })).then(res => {
      if (res.status === 1) {
        this.setState({
          menuList: res.list
        })
        this.getURLData(res.list);
        let THIS = this;
        setTimeout(() => {
          THIS.setState({
            update: true
          })
        }, 1000);
      }
    })
  }
  getURLData = (menuList) => {
    let locaArr = window.location.pathname.split('/');
    locaArr = locaArr.filter(n => n);
    let category = locaArr[1];
    let sub_category = locaArr[2];
    let tsub_category = (locaArr.length === 4 || locaArr.length === 5) ? locaArr[3] : '';
    if (locaArr.length == 2 && locaArr[1] == 'curated-learning-camps') {
      category = locaArr[0];
      sub_category = locaArr[1];
    }
    let carr = menuList.filter(item => item.slug_term == category);
    console.log('carr', carr);
    if (carr.length === 1) {
      carr = carr[0];
      carr.subdata.forEach(function (item, i) {
        if (item.slug_term == sub_category) {
          carr.subdata.splice(i, 1);
          carr.subdata.unshift(item);
        }
      });
      if (tsub_category) {
        commonAPI(JSON.stringify({ url: 'getPmenuBySlug', term: sub_category })).then(res => {
          if (res.status === 1) {
            if (res.list.length > 0) {
              res.list.forEach(function (item, i) {
                if (item.slug_term == tsub_category) {
                  res.list.splice(i, 1);
                  res.list.unshift(item);
                }
              });
              this.setState({
                current_menuList: res.list,
                active_sub_category: sub_category,
                active_category: carr.slug_term,
                active_tsub_category: tsub_category,
                filter_opt: locaArr.length === 5 ? true : false
              })
            } else {
              this.setState({
                current_menuList: carr.subdata,
                active_category: carr.slug_term,
                sidebarOpen: false,
                filter_opt: true
              })
            }
            if (sub_category == 'curated-learning-camps')
              this.setState({
                filter_opt: true
              })
          }
        })
      } else {
        this.setState({
          current_menuList: carr.subdata,
          active_category: carr.slug_term,
          sidebarOpen: false
        })
      }

      let scarr = carr.subdata.filter(item => item.slug_term == sub_category);
      if (scarr.length === 1) {
        scarr = scarr[0];
        this.setState({
          active_sub_category: scarr.slug_term,
        })
      }
    }
  }
  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open });
  }
  componentWillReceiveProps(nextProps) {
    console.log('nextProps.sidemenu on sidemenu', nextProps)
    if (nextProps.sidemenu === true) {
      this.setState({
        sidebarOpen: true,
      })
    }
    if (nextProps.filter_opt === true) {
      this.setState({
        filter_opt: true,
      })
    }
  }
  logoutSess(e) {
    localStorage.clear();
    let toastr = '';
    toastr = window.toastr.success;
    toastr('Logout successful', {
      positionClass: "toast-bottom-center",
      containerId: "toast-bottom-center"
    });
    setTimeout(function () {
      window.location = "/";
    }, 2000);
  }
  openForm = (e) => {
    this.setState({
      contact_modal: true,
      sidebarOpen: false,
    })
  }
  closeForm = (e) => {
    this.setState({
      contact_modal: false
    })
  }
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }
  getNextMenu = (e, i) => {
    e.preventDefault();
    let menuList = this.state.menuList;
    this.setState({
      current_menuList: menuList[i].subdata,
      active_category: menuList[i].slug_term,
        sidebarOpen: false,
      isProfile: false,
    })
  }
  profileMenu = (e) => {
    e.preventDefault();
    this.setState({
      isProfile: true,
      current_menuList: [],
      sidebarOpen: false
    })
  }
  openSignin = (e) => {
    e.preventDefault();
    this.setState({
      sidebarOpen: false
    })
    this.props.onSigninClick(e);
  }
  openSignup = (e) => {
    e.preventDefault();
    this.setState({
      sidebarOpen: false
    })
    this.props.onSignupClick(e);
  }
  filterClick = () => {
    this.props.onFilterClick();
  }
  sortClick = () => {
    this.props.onSortClick();
  }
  render() {
    const {
      screen_size, active_category, active_sub_category, active_tsub_category,
      menuList, current_location, current_menuList, isProfile, filter_opt
    } = this.state;
    let isMobile = false;
    if (screen_size <= 767) {
      isMobile = true;
    }
    let path = window.location.pathname, isHome = false;
    if (path == '/') {
      isHome = true;
    }
    else
      isHome = false;
    // margin-top: 75px;
    // margin-bottom: -110px;
    console.log('this.state.menuList', filter_opt, isHome)
    return (
      <React.Fragment>

        <div className="sidebar-custom-menu">
          <Sidebar
            sidebar={
              <div className="sidebar-right">
                <div className='row'>
                  <div className='col-12'>
                    <button className="sidebar-btn-close pull-right"  aria-label="OpenSidebar" onClick={() => this.onSetSidebarOpen(false)}> <i className="fa fa-times" aria-hidden="true"></i>  </button>
                  </div>
                </div>
                {(this.state.authe === true) && (
                  <React.Fragment>
                    <div className='col-12'>
                      <p className='mb-0'>
                        <b>{this.state.logged_name}</b>
                      </p>
                      {this.state.login_type_name &&
                        <p className='mb-2'><small>logged in through {this.state.login_type_name}</small></p>}
                    </div>
                  </React.Fragment>
                )}
                <ul>
                 
                  {(this.state.authe === true) &&
                    (
                      <div>
                         
                        <li>
                          <div className="wishlist">
                            <a href="/edit_profile" target="_blank" >
                              Edit Profile
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="wishlist">
                            <a href="/wishlist"> <span>Wishlist</span></a>
                          </div>
                        </li>
                        <li>
                          <div className="wishlist">
                            <a href="/compare-list">
                              <span >Compare</span>&nbsp;
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="wishlist">
                            <a href="javascript:;" onClick={(e) => logout(e)}>
                              Logout</a>
                          </div>
                        </li>
                      </div>
                    )}
                </ul>
              </div>
            }
            open={this.state.sidebarOpen}
            onSetOpen={this.onSetSidebarOpen}
            sidebarClassName={"right-sidebar-custom"}
            contentClassName={"sidebar-content"}
            pullRight={true}
            styles={{ sidebar: { background: "white" } }}
          >
          </Sidebar>
        </div>
        {isMobile && (
          <div className='container'>
           
              {/* {isProfile && (
                <div className={'col-12 submenu-list'}>
                  <a href='/edit_profile'>
                    Edit Profile
                  </a>
                  &nbsp;|&nbsp;
                  <a href='/compare-list'>
                    Compare
                  </a>
                  &nbsp;|&nbsp;
                  <a href='/wishlist'>
                    Wishlist
                  </a>
                  &nbsp;|&nbsp;
                  <a href='javascript:;' onClick={this.logoutSess}>
                    Logout
                  </a>
                </div>
              )} */}
              {current_menuList.length>0 && (
                <React.Fragment>
                      
                  {!isHome && !filter_opt && (

                      <div class="row scrollmenu filtermenu" style={isHome ? { marginTop: '75px', marginBottom: '-90px' } : {}}>
                     <div className='col'>
                      <a className='filter-menu' href='javascript:;' onClick={this.filterClick} >
                        <i class="fa fa-filter" title="Sharpen your search"><span class="icontext">Filter</span></i>
                      </a>
                      </div>
                      <div className='col'>
                      <a className='filter-menu' href='javascript:;' onClick={this.sortClick}>
                        <i class="fa fa-sort-alpha-asc" title="Sharpen your search" ><span class="icontext">Sort</span></i>
                      </a>
                      </div>
                      </div>
                    
                  )}
                  
                   <div class="row scrollmenu" style={isHome ? { marginTop: '75px', marginBottom: '-90px' } : {}}>
                  <div className={isHome || filter_opt ? 'col-12 submenu-list' : 'col-10 submenu-list'}>
                    {current_menuList.map((item, i) => {
                      let len = current_menuList.length - 1;
                      return (
                        <React.Fragment>
                          {active_tsub_category ?
                            <a className={active_tsub_category == item.slug_term && 'active'}
                              href={`/${current_location}/${active_category}/${active_sub_category}/${item.slug_term}`}>
                              {item.category_name}</a>
                            :
                            <a className={active_sub_category == item.slug_term && 'active'}
                              href={`/${current_location}/${active_category}/${item.slug_term}`}>
                              {item.category_name}</a>
                          }
                          {len > i && (' | ')}
                        </React.Fragment>
                      )
                    })}
                  </div>
                  </div>
                </React.Fragment>
              )}
            </div>
        )}

        {/* <div
          className='modal fade review-modal'
          id='postQueryModal'
        >
          
        </div> */}
      </React.Fragment>
    );
  }
  handleQuery = (e) => {
    e.preventDefault();

    if (
      this.state.q_comments != '' && this.state.q_name != '' && this.state.q_type != '' &&
      this.state.q_subject != '') {
      let regData = JSON.stringify({
        user_id: this.state.user_id ? this.state.user_id : 0,
        q_type: this.state.q_type,
        name: this.state.q_name,
        email_id: this.state.q_email_id,
        subject: this.state.q_subject,
        phone_no: this.state.q_phone_no,
        comments: this.state.q_comments,
        user_type: this.state.user_type,
      });
      postQuery(regData).then((response) => {
        let toastr = '';
        if (response.status == 1) {
          $('#postQueryModal').hide('');
          $('.modal-backdrop fade').removeClass('show');
          this.setState({
            name: '',
            email_id: '',
            subject: '',
            phone_no: '',
            comments: '',
          })
          toastr = window.toastr.success;
          toastr('', 'Thanks for your query!..', {
            positionClass: "toast-bottom-center",
            containerId: "toast-bottom-center"
          });
          setTimeout(function () {
            window.location.reload();
          }, 1000);
        } else {
          toastr = window.toastr.error; //warning
          toastr('', 'Required!...', {
            positionClass: "toast-bottom-center",
            containerId: "toast-bottom-center"
          });
        }
      });
    } else {
      let toastr = '';
      if (this.state.q_name == '') {
        toastr = window.toastr.error; //warning
        toastr('Error', 'Name Required!...', {
          positionClass: "toast-bottom-center",
          containerId: "toast-bottom-center"
        });
      } else if (this.state.q_type == '') {
        toastr = window.toastr.error; //warning
        toastr('Error', 'Query type Required!...', {
          positionClass: "toast-bottom-center",
          containerId: "toast-bottom-center"
        });
      } else if (this.state.q_email_id == '') {
        toastr = window.toastr.error; //warning
        toastr('Error', 'Email. Required!...', {
          positionClass: "toast-bottom-center",
          containerId: "toast-bottom-center"
        });
      } else if (this.state.q_subject == '') {
        toastr = window.toastr.error; //warning
        toastr('Error', 'Subject Required!...', {
          positionClass: "toast-bottom-center",
          containerId: "toast-bottom-center"
        });
      } else if (this.state.q_comments == '') {
        toastr = window.toastr.error; //warning
        toastr('Error', 'Comments Required!...', {
          positionClass: "toast-bottom-center",
          containerId: "toast-bottom-center"
        });
      }

    }
  };
}
class PNotification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: localStorage.getItem("logged_auth") ? localStorage.getItem("logged_auth") : false,
      auth_data: localStorage.getItem("myData") ? JSON.parse(localStorage.getItem("myData")) : {},
      isPartner: false,
      showNotifi: false,
      notification_list: []
    };
  }
  componentDidMount() {
    if (this.state.auth == 'true' && this.state.auth_data) {
      console.log('this.state.isPartner', this.state.auth_data.isPartner);
      if (this.state.auth_data.isPartner != undefined && this.state.auth_data.isPartner != 0) {
        this.getNotification()
      }
      this.setState({
        isPartner: this.state.auth_data.isPartner != undefined && this.state.auth_data.isPartner != 0 ? true : false
      })
    }
  }
  getNotification = () => {
    let req = JSON.stringify({
      role: 4,
      partner_id: this.state.auth_data.isPartner,
      url: 'get_pnotification'
    });
    pNotification(req).then(res => {
      if (res.status === 1) {
        this.setState({
          notification_list: res.list
        })
      }
    })
  }
  dimissNotif = (index) => {
    let notification_list = this.state.notification_list;
    notification_list[index].is_read = 0;
    this.setState({
      notification_list
    })
    let req = JSON.stringify({
      role: 4,
      noti_id: notification_list[index].id,
      url: 'read_notif'
    });
    pNotification(req);
  }
  render() {
    let count = this.state.notification_list.filter(item => item.is_read == 1).length;
    return (
      <React.Fragment>
        {this.state.isPartner &&
          <div className='noti-sec'>

            <Dropdown direction={'left'} isOpen={this.state.showNotifi}>
              <DropdownToggle
                data-toggle="dropdown"
                tag="span"
              >
                <div className='pointer' >
                  <i class="fa fa-bell" aria-hidden="true"></i> {count > 0 && <span className='noti-count'>{count}</span>}
                </div>

              </DropdownToggle>
              <DropdownMenu className='noti-drop-sec' container="body">
                {count > 0 ?
                  this.state.notification_list.map((item, i) => {
                    if (item.is_read == 1)
                      return (
                        <DropdownItem className='noti-list' >
                          {item.text}
                          <span className='pull-right' onClick={() => this.dimissNotif(i)}>
                            <i class="fa fa-times pl-5" aria-hidden="true"></i>
                          </span>
                        </DropdownItem>
                      )
                  })
                  :
                  <DropdownItem className='noti-list' >
                    No items Found
                  </DropdownItem>
                }
              </DropdownMenu>
            </Dropdown>

          </div>
        }
      </React.Fragment>
    );
  }
}
class TermsCondtions extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentDidMount() {
  }
  render() {
    return (
      <React.Fragment>
        <div className="privacy-page">

        <p><strong>General</strong></p>

<p><span style={{color:"#0563c1"}}><u><a href="http://www.BeWise.in/">www.BeWise.in</a></u></span> is an online platform and BEWISE App (&ldquo;App&rdquo;) is the mobile application, owned by Wisdom Tech Solutions Private Limited, a private limited company incorporated under the Companies Act, 2013, having its registered office at Karnataka (&ldquo;Company&rdquo;), represented by its members, where such expression shall, unless repugnant to the context thereof, be deemed to include its respective legal heirs, representatives, administrators, permitted successors and assigns.</p>

<p>This website/App is an online platform/mobile application that is engaged in the business of providing and facilitating parents make choice around their child&rsquo;s &ldquo;education and development&rdquo; by discovering preschool/daycare/ after school/events/ activity class for their child in and around them. We ensure we provide details of relevant partners and constantly provide you updates on them. On the other side, if you are an institution or an individual supporting this &ldquo;holistic education&rdquo;, we also understand the pressures of growth and ability to effectively reach target audience, benchmarking, and continuous improvement with feedback which are critical for a sustainable future in a fast-paced digital economy. Hence, we provide them this platform to overcome their problem of right audience through our website and App.</p>

<p>For the purpose of these Terms and Conditions, wherever the context so requires, the term &quot;you&quot; or &quot;user&quot; shall mean any natural or legal person or entity including accessing or using the services provided on this website/App. The terms &ldquo;we&rdquo;, &ldquo;us&rdquo; and &ldquo;our&rdquo; shall mean BeWise and the terms &lsquo;site&rsquo; or &lsquo;website&rsquo; refers to www.BeWise.in.</p>

<p>The headings of each section in this Agreement (as defined below) are only for the purpose of organizing the various provisions under this Agreement in an orderly manner. These headings shall not be used by either party to interpret the provisions contained with them in any manner. Further, the headings have no legal or contractual value.</p>

<p><strong>Acceptance of our Terms</strong></p>

<p>By visiting this website/App, viewing, accessing or otherwise using any of the services or information created, collected, compiled or submitted to BeWise, you agree to be bound by the Terms and Conditions (&lsquo;Terms&rsquo;) mentioned hereunder.</p>

<p>If you do not want to be bound by our Terms your only option is not to visit, view or otherwise use the services of BeWise. You understand, agree and acknowledge that these Terms and the Privacy Policy (please refer to the Privacy Policy section of the website/App for more information) of BeWise, collectively, constitute a legally binding agreement between you and BeWise and that your use of BeWise shall indicate your conclusive acceptance of this agreement (&lsquo;Agreement&rsquo;). You are advised to read the Terms and the Privacy Policy carefully before you use the services of this site/App.</p>

<p><strong>Eligibility</strong></p>

<p>Use of this site/App is available only to persons who can form legally binding contracts under applicable law. Persons who are &lsquo;incompetent to contract&rsquo; within the meaning of the laws applicable to them in their respective jurisdiction are not eligible to use this site/App. You may use this site/App only if your age is over 18 years and you are capable of forming binding contracts under applicable law.</p>

<p>BeWise reserves the right to freeze your account and refuse to provide you with access to this site/App if BeWise discovers that you are under the age of 18 years or otherwise not capable of forming binding contracts. In case of a business entity, you represent that you have the necessary authority to bind the entity to this Agreement.</p>

<p>Unless otherwise specified, the materials on this website/App are directed solely at those who access this website/App from India. BeWise makes no representation that any content referred to in the materials on this website/App are appropriate for use, or available outside India. Those who choose to access this site/App from outside India are responsible for compliance with local laws if and to the extent local laws are applicable.</p>

<p><strong>User&rsquo;s Account</strong></p>

<p>You are required to create an account on the website/App in order to use some of the features and services offered by BeWise, including, without limitation to, booking for services, reviewing a partner and availing offers and discounts. The use of any information you share with us to create your account is governed by our Privacy Policy.</p>

<p>It is the user&rsquo;s responsibility to keep the details of the account and password confidential and you agree to accept responsibility for all activities that occur under your account or password. BeWise shall not be liable to any person for any loss or damage which may arise as a result of any failure by the user to protect the account details or the password. In case of any suspected breach, please contact us immediately. If BeWise has reason to believe that there is likely to be a breach of security or misuse of this site/App, we may require you to change your password or we may permanently suspend your account without any liability to BeWise.</p>

<p><strong>You also agree to:</strong></p>

<p>provide true, accurate, current and complete information about yourself as prompted by BeWise while signing up on this website/App.</p>

<p>maintain and promptly update the account related information to keep it true, accurate, current and complete. If you provide any information that is untrue, inaccurate, incomplete, or not current or if BeWise has reasonable grounds to suspect that such information is untrue, inaccurate, not current or not in accordance with this Agreement, or if in the opinion of BeWise, your use of this website/App breaches the terms of the applicable law, or the rights of any person, or is detrimental in any way to BeWise, we will have the right to indefinitely suspend or discontinue your account and refuse to provide you with access to this site/App.</p>

<p>Further, you may be able to log into the website/App by linking a social media account such as Facebook, Instagram, LinkedIn, twitter or Google accounts. You confirm that you are the owner of any social media account you log in with and that you are entitled to disclose your social media account information to us. Further, you give us permission to collect your authentication information, and other information that may be available on or through your social media account consistent with your applicable settings and instructions.</p>

<p>You are solely responsible for all activities that occur in your account. You agree to notify us immediately of any unauthorized use of your account in order to enable us to take necessary corrective action. You also agree that you will not allow any third party to use your account for the purpose of transacting in your name on our website/App.</p>

<p><strong>User&rsquo;s obligations</strong></p>

<p>You are a restricted user of this website/App.</p>

<p>You are bound not to cut, copy, distribute, modify, recreate, reverse engineer, distribute, disseminate, post, publish or create derivative works from, transfer, or sell any information or software obtained from the website/App. With our prior permission, limited use may be allowed. For the removal of doubt, it is clarified that unlimited or wholesale reproduction, copying of the content for commercial or non-commercial purposes and unwarranted modification of data and information within the content of the website/App is not permitted.</p>

<p>You agree not to access (or attempt to access) the website/App and/or the materials or services by any means other than through the interface that is provided by the website/App. The use of deep-link, robot, spider or other automatic device, program, algorithm or methodology, or any similar or equivalent manual process, to access, acquire, copy or monitor any portion of the website/App or content, or in any way reproduce or circumvent the navigational structure or presentation of the website/App, materials or any content, to obtain or attempt to obtain any materials, documents or information through any means not specifically made available through the website/App.</p>

<p>In places where this website/App allows you to post or upload data/information, you undertake to ensure that such material is not offensive and in accordance with applicable laws.</p>

<p>You shall not impersonate any other party, create or use an account for anyone other than yourself, provide an email address other than your own, create multiple accounts, except as otherwise authorized by us, or provide or use false information of any kind.</p>

<p>We can (and you hereby expressly authorize us to) disclose any information about you to law enforcement or other government officials, as we, in our sole discretion, believe necessary or appropriate in connection with the investigation and/or resolution of possible crimes, especially those that may involve personal injury.</p>

<p>You understand that we have the right at all times to disclose any information (including the identity of the persons providing information or materials on the website/App) as necessary to satisfy any law, regulation or valid governmental request. This may include, without limitation, disclosure of the information in connection with investigation of alleged illegal activity or solicitation of illegal activity or in response to a lawful court order.</p>

<p>We have no obligation to monitor the materials posted on the website/App. We shall have the right to remove or edit any content that, in our sole discretion, violates, or is alleged to violate, any applicable law or either the spirit or letter of these Terms or for any other reason or no reason if we consider it to be objectionable, in violation of the Terms or otherwise harmful to the website/App or other users. Subject to the requirements of applicable law, we are not obligated to return any of your content to you under any circumstances. Any review, which is derogatory, defamatory or hateful and without any substantial evidence (e.g. photograph or video) may be taken down at our sole discretion. Notwithstanding this right, YOU REMAIN SOLELY RESPONSIBLE FOR THE CONTENT OF THE MATERIALS YOU POST ON THE WEBSITE/APP. In no event shall we assume or have any responsibility or liability for any content posted or for any claims, damages or losses resulting from use of content and/or appearance of content on the website/App. You hereby represent and warrant that you have all necessary rights in and to all content which you provide and all information it contains and that such content shall not infringe any proprietary or other rights of third parties or contain any libelous, tortuous, or otherwise unlawful information.</p>

<p><strong>Contents and submissions</strong></p>

<p>We welcome your suggestions, comments and reviews regarding your experience using our website/App. Any comments, ideas, suggestions, initiation, or any other content you contribute to this site/App (including the name you submit with any content) will be deemed to include a royalty-free, perpetual, irrevocable, nonexclusive right and license for BeWise to adopt, publish, reproduce, disseminate, transmit, distribute, copy, use, create derivative works, display worldwide, or act on such content, without additional approval or consideration, in any, media, or technology now known or later developed for the full term of any rights that may exist in such content, and you waive any claim to the contrary.</p>

<p>The user acknowledges that all reviews and ratings that users submit to this website, for whatever purpose, is public and not private/confidential information. BeWise specifically disclaims any liability concerning such information and any actions resulting from the user&rsquo;s participation in such content, including any objectionable content.</p>

<p>You represent and warrant that you own or otherwise control all of the rights to the content that you contribute to this site/App and that use of your content by BeWise will not infringe upon or violate the rights of any third party.</p>

<p>You further represent that your content is truthful and accurate; and your content does not violate these Terms or any applicable laws. If your content is a review, you represent and warrant that you are the sole author of that review; the review reflects that you had no financial, competitive, or other personal incentive to author or post a review that was not a fair expression of your honest opinion.</p>

<p>You assume all risks associated with your content, including anyone&#39;s reliance on its quality, accuracy, or reliability, or any disclosure by you of information in your content that makes you personally identifiable. While we reserve the right to remove content, we do not control actions or content posted by our users and do not guarantee the accuracy, integrity or quality of any content. You acknowledge and agree that content posted by users and any and all liability arising from such content is the sole responsibility of the user who posted the content, and not us.</p>

<p>Any review posted by a user does not reflect our opinion in any way. Each and every review posted on the website/App is the personal opinion of the user only. We are a neutral platform and solely provide a means of communication between users. Any advertisements on the website/App are published on an independent basis and there is no relation between the reviews of advertisers those who have advertised on the website/App. If the business user believes that any particular user&rsquo;s review violates these Terms and our policies, the user can flag the review to our attention. We may remove the review in our sole discretion.</p>

<p><strong>Services by Partners</strong></p>

<p>BeWise is not liable for the information provided by the individual and institutional partners (&lsquo;Partners&rsquo;) listed on this website/App. The user understands that the information provided by the Partners may or may not have been verified by BeWise, therefore, the user shall exercise his/her own independent judgment while choosing from the options of Partners listed on this website/App.</p>

<p>The information provided by the Partners is tentative and subject to change at any time at their sole discretion and BeWise is not liable for any such change or modification in the information provided by the Partners.</p>

<p>This website/App allows the user to access the information provided by the Partners and contact them directly through call, text message or via e-mail. BeWise is not liable for transmission of user&rsquo;s phone number or such other information which may be shared by the user with the Partners directly or indirectly through such means.</p>

<p>The user may avail services including the in-person services (such as availing services of nannies, home tutors, etc.) for their ward from the Partners listed on this website/App at their own risk. BeWise does not conduct any police verification or KYC of any of the Partners listed on the website/App in any case, therefore, the user shall be solely responsible to conduct independent verifications and choose from the listed options at its sole discretion. BeWise shall not be liable upon occurrence of any undesirable event, whatsoever, arising out of non-verification on part of the user or BeWise of such Partners.</p>

<p><strong>Teacher Career Portal:</strong></p>

<p><strong>The teacher career portal is a platform provided by BeWise for teachers and educational institutions to connect and explore employment opportunities. BeWise acts as an intermediary facilitating the interaction between teachers seeking employment and educational institutions seeking teachers.</strong></p>

<p><strong>For Teachers:</strong></p>

<p><strong>BeWise does not guarantee or endorse the accuracy, reliability, suitability, or quality of the job postings by educational institutions on the portal. It is the responsibility of the teachers to evaluate and verify the authenticity, legitimacy, and suitability of the job opportunities before applying.</strong></p>

<p><strong>BeWise is not responsible for the actions, conduct, or performance of any educational institution or individual hiring entity using the portal. Teachers are solely responsible for conducting their own due diligence, including researching and assessing the reputation, credentials, and working conditions of the educational institution or hiring entity.</strong></p>

<p><strong>BeWise does not guarantee employment or any specific job placement to teachers using the portal. The hiring decisions and terms of employment are solely at the discretion of the educational institution or hiring entity.</strong></p>

<p><strong>For Educational Institutions:</strong></p>

<p><strong>BeWise does not endorse or verify the qualifications, skills, or experience of teachers posting their profiles on the portal. It is the responsibility of the educational institutions to evaluate and verify the credentials and suitability of the teachers before making hiring decisions.</strong></p>

<p><strong>BeWise is not liable for any misrepresentation, false information, or misconduct of teachers using the portal. Educational institutions are solely responsible for conducting their own background checks, interviews, and assessments of the teachers.</strong></p>

<p><strong>BeWise does not guarantee the availability or suitability of teachers for specific job vacancies. The selection of teachers and the terms of employment are solely at the discretion of the educational institution.</strong></p>

<p><strong>Limitation of Liability:</strong></p>

<p><strong>BeWise shall not be liable for any claims, damages, losses, or liabilities arising from the interaction, engagement, or employment between teachers and educational institutions facilitated through the teacher career portal. Users of the portal agree to release BeWise from any such claims or disputes.</strong></p>

<p><strong>BeWise recommends users to exercise caution, diligence, and professional judgment while using the teacher career portal. Users are encouraged to independently verify information, conduct interviews, and perform necessary checks before making any decisions or entering into any agreements.</strong></p>

<p><strong>Payment and Refunds:</strong></p>

<p><strong>Payments made by teachers and educational institutions on the teacher career portal are non-refundable, except as expressly provided in this agreement or as required by applicable law.</strong></p>

<p><strong>The pricing and packages listed on the website are subject to finalization at the time of entering into an agreement between BeWise and the user (teacher or educational institution). The specific terms, duration, and scope of the package will be outlined in the agreement and may affect the payment amount.</strong></p>

<p><strong>In the event of any dispute or disagreement regarding payment, users agree to contact BeWise and attempt to resolve the issue in good faith. However, BeWise reserves the right to make the final determination regarding refunds, adjustments, or credits, if any, on a case-by-case basis.</strong></p>

<p><strong>Third-Party Services - </strong></p>

<p><strong>BeWise may collaborate with third-party providers to host their services, content, or resources on our platform. However, it is essential to note that we do not have any direct liability for the content or services provided by these third parties. The inclusion of third-party services on our website does not imply endorsement or approval of their offerings. Users engaging with third-party services do so at their own risk and must adhere to the respective third-party providers&#39; terms and conditions.</strong></p>

<p><strong>All intellectual property rights, including but not limited to copyrights, trademarks, and patents, related to BeWise and its content remain our sole property or that of our licensors. Users are prohibited from reproducing, distributing, or using any content from our website without obtaining explicit written consent from us.</strong></p>

<p><strong>While we strive to provide accurate and up-to-date information, BeWise does not warrant the completeness, accuracy, or reliability of the content or services provided by 3</strong><sup><strong>rd</strong></sup><strong> Party. We are not liable for any direct or indirect damages or losses arising from the use of our website or any third-party services hosted on it. </strong></p>

<p><strong>We reserve the right to terminate or suspend access to our services at any time without prior notice, including for any violation of these Terms and Conditions or any applicable laws. </strong></p>

<p><strong>Third-Party Hosted Events and Monetary Rewards</strong></p>

<p><strong>BeWise may facilitate events hosted by third-party providers on our platform. These events may involve the provision of monetary rewards to participants or winners. It is essential to understand that BeWise acts solely as a platform for hosting such events and does not have any direct involvement in organizing, conducting, or funding these events.</strong></p>

<p><strong>We explicitly disclaim any liability, responsibility, or obligation regarding the organization, administration, outcomes, or consequences of the events hosted by third parties on our platform. The third-party providers solely determine the terms, rules, eligibility criteria, and distribution of monetary rewards for their events.</strong></p>

<p><strong>Participants in these events are subject to the rules, terms, and conditions set forth by the third-party provider. Any claims, disputes, or issues arising from participation in such events must be directed to the respective third-party provider, and BeWise shall not be held liable for any damages, losses, or disputes resulting from these events.</strong></p>

<p><strong>By participating in third-party hosted events on BeWise, users acknowledge and agree to release, indemnify, and hold us harmless from any claims, demands, or actions arising from or related to these events.</strong></p>

<p><strong>Please note that BeWise does not endorse, warrant, or guarantee the accuracy, legitimacy, or safety of any events hosted by third parties on our platform. Users participate in these events at their own risk and discretion.</strong></p>

<p><strong>Success Fee for Third-Party Hosted Events</strong></p>

<p><strong>In consideration for providing a platform for hosting third-party events and facilitating the distribution of monetary rewards to winners, BeWise (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;) may be entitled to a success fee. This success fee is based on a predetermined percentage or amount of the total monetary rewards provided by the third-party host to the event participants or winners.</strong></p>

<p><strong>Additionally, BeWise may also receive a separate success fee directly from the third-party provider, based on a separate agreement between BeWise and the respective third-party provider.</strong></p>

<p><strong>By participating in third-party hosted events on BeWise, users acknowledge and agree to any applicable deductions, including the deduction of the success fee from the monetary rewards they receive, if any. The success fee, when applicable, will be deducted by BeWise from the monetary rewards before their disbursement to the event participants or winners.</strong></p>

<p><strong>It is important to note that BeWise does not have any control over the determination or distribution of the success fee by the third-party provider. The success fee, if applicable, will be disclosed to the event participants before their participation, and any questions or concerns regarding the success fee should be directed to </strong><span style={{color:"#0563c1"}}><u><a href="mailto:contact@bewise.in"><strong>Contact@bewise.in</strong></a></u></span></p>

<p><strong>Third-Party Courses and Content</strong></p>

<p><strong>BeWise (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;) acts as a platform for hosting and distributing third-party courses and content provided by external teachers and institutions. As such, BeWise functions both as a carrier or distributor of information and as a facilitator of these courses.</strong></p>

<p><strong>In consideration for providing a platform for hosting third-party courses, BeWise may receive a fee from such 3</strong><sup><strong>rd</strong></sup><strong> party providers offering their courses on our platform. This fee is based on a predetermined agreement between BeWise and the respective third-party providers.</strong></p>

<p><strong>However, it is essential to understand that while BeWise facilitates the availability of third-party courses, we do not directly manage, control, or endorse the content, teaching methodologies, or delivery promises of these courses. Learners, teachers, and institutions are encouraged to exercise their own discretion and judgment when enrolling in or participating in any third-party courses on BeWise.</strong></p>

<p><strong>BeWise does not provide any warranties or guarantees regarding the accuracy, quality, completeness, or outcomes of the courses offered by external providers. Any reliance on the information provided by these third parties is done at the user&#39;s own risk.</strong></p>

<p><strong>We do not enter into any direct contractual relationships with the teachers, institutions, or learners regarding the courses or content hosted on our platform. Any contractual arrangements or agreements are solely between the users and the respective third-party providers.</strong></p>

<p><strong>In case of any disputes, concerns, or issues related to third-party courses or content, users should directly contact the relevant external provider. BeWise shall not be held liable for any damages, losses, or disputes arising from the interaction between users and external providers.</strong></p>

<p><strong>Franchisee Advertisements</strong></p>

<p><strong>BeWise (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;) may facilitate the advertisement of franchisee opportunities on our platform. These advertisements are provided as a service to our users, and we act solely as an intermediary in connecting potential franchisee owners with the relevant schools or institutions offering franchisee opportunities.</strong></p>

<p><strong>It is essential to note that BeWise does not take responsibility for any enquiries, communications, or interactions made between users and the franchisee owners through our platform. Any discussions, agreements, or transactions that occur as a result of the franchisee advertisements are solely between the users and the respective franchisee owners.</strong></p>

<p><strong>BeWise disclaims any liability or responsibility for the accuracy, legitimacy, or outcomes of the franchisee opportunities advertised on our platform. Users are advised to conduct their own due diligence, verify the details, and assess the suitability of any franchisee opportunity before entering into any agreements or commitments.</strong></p>

<p><strong>Franchisee owners advertising on BeWise shall have no liability or claims against us arising from user enquiries, interactions, or outcomes related to their advertisements. Any disputes, concerns, or issues between users and franchisee owners should be addressed directly between the parties involved, and BeWise shall not be held responsible for any such matters.</strong></p>

<p><strong>Communications</strong></p>

<p>By using this website/App, it is deemed that you have consented to receiving calls, autodialed and/or pre-recorded message calls, e-mails and SMSs from us at any time with the use of the contact information that has been provided by you for the use of this website/App which is subject to the Privacy Policy. This includes contacting you through information received through other parties. This consent to be contacted is for purposes that include and are not limited to clarification, marketing and promotional calls, e-mails and messages. In case you wish to stop being contacted by us for the same, you may send us an e-mail to that effect at contact@bewise.in.</p>

<p>You may also be contacted by the Partners with whom we have entered into a contract in furtherance of our rights, duties and obligations under this document and all other policies followed by us. Such contact will be made only in pursuance of such objectives, and no other calls will be made.</p>

<p>The sharing of the information provided by you will be governed by BeWise&rsquo;s Privacy Policy and we will not give out your contact information to third parties not connected with this website/App.</p>

<p><strong>Permissions</strong></p>

<p>We or our affiliates responsible for making the software available, may design our website or App in such a manner as to automatically check for updates. Unless your device or any settings do not permit automatic transmission, upgrades or updates, you agree that we, or the applicable software affiliate, may provide notice to you of the availability of such upgrades or updates and automatically push such upgrade or update to your device or computer from time-to-time. You may be required to install certain upgrades or updates to the software in order to continue to access or use the services, or portions thereof (including upgrades or updates designed to correct issues with the services). Any updates or upgrades provided to you by us under these Terms shall be considered part of the services.</p>

<p>BeWise has the right, but not the obligation to monitor and edit or remove any content posted by you as your communication. We cannot review all communications made on the site/App. However, we reserve the right, but has no obligation, to monitor and edit, modify or delete any communications (or portions thereof) which we, on our sole discretion, deem inappropriate, offensive or contrary to any of our policy, or that violate theses terms.</p>

<p><strong>Deals and offers</strong></p>

<p>BeWise provides an opportunity to users to avail offers/value deals from the Partners listed on the website/App. BeWise allows users to book from amongst the services with offers listed on them on the website or App. The user is aware that the term &quot;Deal (Discount)&quot; here means the limited promotional offer, which is valid for the Promotional Period (as defined below) only, made by the company, in terms of which the company offers to supply certain products and services at a discounted rate and the term &quot;Promotional Period&quot; means the period of time during which a Deal can be availed for the products and services offered on the website/App. Each deal is limited and accordingly, will be sold on case-by-case basis on individual services offered on the website/App&rsquo;s promotional page. Each Deal has certain specific terms associated with the Deal, which will be presented to the user before the user commits to purchase the particular product or service. Deal specific terms supersede any inconsistent terms in this Agreement, except to the extent such terms are prohibited by applicable law. The Promotional Period (including, but not limited to, any discounts provided by the website/App) expires on a specific date specified on the website/App. After the expiry date of the Promotional Period, such deals or offers become invalid.</p>

<p><strong>Charges</strong></p>

<p>The membership of this website/App for the user is free of cost. You only must pay for the services purchased. However, we reserve the right to amend this no-fee policy and charge for any or all services rendered.</p>

<p><strong>Mode of payment</strong></p>

<p>The following payment options are or will be made available on the Website/App in the future:</p>

<p>Domestic and international credit cards issued by banks and institutions that are part of the Visa, Master card &amp; Amex Card;</p>

<p>Visa Debit cards;</p>

<p>Netbanking/Direct Debit payments from select banks in India. A list of banks is available at the time of &lsquo;checkout&rsquo;;</p>

<p>Payment processing apps like Paytm, Gpay, Razorpay, BHIM, Phonepe, Mobikwik, Yono, Payzapp, Amazon pay etc.</p>

<p>As prescribed by the financial institutions issuing the credit or debit cards affiliated with Visa and MasterCard you will be required to submit your 16-digit credit card number, card expiry date and 3-digit CVV number (usually on the reverse of the card) when you make your online transaction using your credit or debit card. You should also have enrolled your credit card with VBV (Verified by Visa) or MSC (MasterCard Secure Code) to complete the transaction. Your credit card or debit card statements will reflect Wisdom Tech Solutions Pvt Ltd. In case of third-party statements including bank and credit card statements the company name may appear in an abbreviated format. This may or may not be assisted with a phone call with the customer service representative. By placing an order on the website/App, you are agreeing to the terms and conditions and payment policy published in the appropriate section of the website/App or affiliated websites where specifically referred to such affiliated websites.</p>

<p>Once payment has been made to the Partner, they will receive the SMS or mail with booking details along with Service/Transaction ID, Login ID, One Time code.</p>

<p>Transactions on this website/App are secure and protected. Credit card and debit card information is not stored by us and is not taken by us. This information is taken directly by the payment gateway provided who is authorized and is compliant with the regulations and requirements of various banks and institutions and payment franchisees that it is associated with.</p>

<p>Intellectual Property Rights</p>

<p>This entire BeWise website/App has all rights reserved. The original contents of this website/App are copyrighted materials and are subject to the restrictions and protections set forth in the Copyright Act, 1957.</p>

<p>Unless we have otherwise agreed, nothing herein gives the user, a right to use any of the website/App&rsquo;s trade names, trademarks, service marks, logos, domain names, information, questions, answers, solutions, reports and other distinctive brand features, save according to the provisions of this Agreement.</p>

<p>All content, except if it relates to the individual and institutional partners, present on this site/App is the exclusive property of BeWise. The software, text, images and graphics used on this site/App belong to BeWise. The material present on this website/App may be downloaded to file or printer for personal use only. Where this material is being issued to others, the source including the URL and copyright status must be acknowledged.</p>

<p>The permission to reproduce such copyright material does not extend to any material on this site/App, which may be the property of a third party. This site/App may contain words and phrases, which are copyrighted, trademarked, or registered trademarks; they are the copyright, trademark, or registered trademark of their respective holder(s). Authorization to reproduce such material must be obtained from the respective holders concerned.</p>

<p>BeWise does not allow the user to directly or indirectly, modify, adapt, alter, reverse engineer any of the intellectual property of this website/App.</p>

<p>The Logo is the property of BeWise and may not be used by third parties in any manner that implies that the user is acting on behalf of BeWise when they are not, or where it is linked to aims and activities incompatible with the role and responsibilities of BeWise.</p>

<p>BeWise&rsquo;s logo may be used for events/ programmes/ projects that are funded wholly or in part by BeWise. BeWise&rsquo;s logo may be used by a third party only with the prior written permission from BeWise, which may be granted only at the sole discretion of BeWise. All rights not expressly granted herein are reserved. Unauthorized use of the materials appearing on this site/App may violate copyright, trademark and other applicable laws, and could result in criminal and/or civil penalties.</p>

<p>You may not use any of our intellectual property in any manner that is likely to cause confusion among customers, or in any manner that disparages or discredits us in any way. You further acknowledge that the website/App or services may contain information which is designated as confidential by us and that you shall not disclose such information without our prior written consent.</p>

<p>We do not warrant or represent that your use of any content or materials displayed on the website will not infringe rights of third parties not affiliated with us. You agree to immediately notify us upon becoming aware of any claim that any content on the website/App or any services infringe upon any intellectual property of any party including, but not limited to, copyright, trademark, or other contractual, statutory, or common law rights.</p>

<p><strong>Lawful usage</strong></p>

<p>You agree and confirm that you will use the services provided by BeWise for lawful purposes only and comply with all applicable laws and regulations while using this site/App. The user agrees to provide true, accurate, complete and current information in all instances where such information is requested.</p>

<p>BeWise reserves the right to confirm and validate the information and other details provided by you at any point of time. If upon confirmation your details are found not to be true (wholly or partly), BeWise has the right in its sole discretion to reject the registration and debar you from using the services of BeWise without prior intimation whatsoever.</p>

<p><strong>Prohibited usage</strong></p>

<p>The user shall not use this site/App while, including, but not limited to, rating a Partners or posting a review, for any of the following purposes:</p>

<p>Disseminating any unlawful, harassing, abusive, threatening, harmful, vulgar, obscene, or otherwise objectionable material.</p>

<p>Transmitting material that encourages conduct that results in civil liability or otherwise breaches any relevant laws, regulations or code of practice or constitutes a criminal offence.</p>

<p>Gaining unauthorized access to other computer systems.</p>

<p>Interfering with any other person&rsquo;s use or enjoyment of this site/App.</p>

<p>Breaching any applicable laws.</p>

<p>Interfering or disrupting networks or websites connected to this site/App.</p>

<p>Making, transmitting or storing electronic copies of materials protected by copyright without the permission of the respective owner.</p>

<p><strong>Limitation of Liability and warranty disclaimers</strong></p>

<p>BeWise will not be liable for indirect, special, or consequential damages (or any loss of revenue, profits, or data) arising in connection with this Agreement.</p>

<p>BeWise is not liable for any loss resulting from any action taken or reliance made by you on any information or material posted on this website/App (including, without limitation, Partner and other third party information).</p>

<p>BeWise discounts/offers are promotional offers and shall be subject to the standard terms and conditions and specific terms and conditions. BeWise discounts/offers are issued by the institutions/individual partner and only such institutions shall be responsible for, damages, charges, expenses, claims, liabilities and costs suffered by or in respect of a user, caused in whole or in part by the institutions or which arises out of the goods and/or services provided.</p>

<p>BeWise is not responsible for lost or stolen vouchers or the reference number mentioned on it. These vouchers cannot be combined with any other gift vouchers, third party vouchers, or promotions, unless otherwise specified by the Institution.</p>

<p>In respect of Individual Partner who offer their services listed on our platform through a medium (online or otherwise) outside of the host country (in this case outside India), the legal requirement along with taxation implications of the same would be borne by the user and the respective Partner. The company is not responsible for any such implications arising from the transaction between both user and Partner.</p>

<p>In no event will BeWise be liable for damages of any kind, including without limitation, direct, incidental or consequential damages (including, but not limited to, damages for lost profits, business interruption and loss of programs or information) arising out of the use of or inability to use BeWise&#39;s website/App, or any information provided on the website/App, or any claim attributable to errors, omissions or other inaccuracies in the content or interpretations thereof.</p>

<p>THIS SITE/APP, AND ALL CONTENT, MATERIALS, INFORMATION, SOFTWARE AND SERVICES PROVIDED ON THIS SITE/APP, ARE PROVIDED ON AN &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot; BASIS. BEWISE EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON- INFRINGEMENT.</p>

<p>THE INFORMATION CONTAINED IN THIS SITE/APP HAS BEEN OBTAINED FROM INDIVIDUAL &amp; INSTITUTIONAL PARTNERS AND OTHER SOURCES BELIEVED TO BE RELIABLE. BEWISE DISCLAIMS ALL WARRANTIES AS TO THE ACCURACY, COMPLETENESS OR ADEQUACY OF SUCH INFORMATION.</p>

<p>You agree that institutions will have their own applicable terms and conditions, in relation to their own supply of their goods and services, and also agree to, and shall abide by those terms and conditions. The responsibility to do so is yours alone.</p>

<p>BeWise makes no warranty that: (a) this site/App will meet your requirements; (b) this site/App will be available on an uninterrupted, timely, secure, or error-free basis; (c) the results that may be obtained from the use of this site/App or any services offered through this site/App will be accurate or reliable.</p>

<p>The limitations and exclusions in this section apply to the maximum extent permitted by applicable law.</p>

<p><strong>Indemnity</strong></p>

<p>You agree to defend, indemnify and hold harmless BeWise, its affiliates, employees, directors, officers, agents and their successors and assigns from and against any and all claims, liabilities, damages, losses, costs and expenses, including attorney&rsquo;s fees, caused by or arising out of claims based upon your actions or inactions, which may result in any loss or liability to us or any third party including, but not limited to, posting of obscene or inappropriate content while reviewing any Partner listed on this website/App, providing misleading information while registering on this website/App, breach of any warranties, representations or undertakings or in relation to the non-fulfillment of any of your obligations under this Agreement or arising out of the violation of any applicable laws, regulations including, but not limited to, intellectual property rights, defamation, violation of rights of privacy or publicity or other rights. Your obligations under this part of this Agreement shall survive the expiry or cessation of this Agreement.</p>

<p><strong>Links to external sites</strong></p>

<p>Information on our website/App may occasionally include some links which may lead to other websites, including those operated and maintained by third parties or such other third-party sites that might be directly or indirectly related to the individual or institutional partners listed on our website/App. BeWise includes these links solely as a convenience to you and the presence of such a link does not imply a responsibility on BeWise for the linked site or an endorsement of the linked site, its operator, or its contents.</p>

<p><br />
&nbsp;</p>

<p>Please be aware that once you click on the link to one of these sites, you will be subject to that site&#39;s privacy policy and not to ours. We recommend that you examine each website&#39;s/App&rsquo;s Privacy Policy separately.</p>

<p>BeWise also uses social networking services such as Facebook, Twitter, LinkedIn and Instagram to connect with the users and the public. When you connect with us using these services, we may collect your personal information to communicate with you. The social networking service will also handle your personal information for its own purposes. These social networking services have their own privacy policies. You can access the privacy policies for these social networking services on their websites.</p>

<p><strong>Privacy</strong></p>

<p>The user&#39;s right to privacy is of paramount importance to BeWise, which is why we&#39;ve created a separate Privacy Policy in order to explain in detail how we collect, manage, process, secure, and store your personal information. To read our privacy policy in its entirety, go to the Privacy Policy section of this website/App.</p>

<p>By using this website/App, you agree to acceptance of BeWise&rsquo;s Privacy Policy.</p>

<p><strong>Modifications</strong></p>

<p>We reserve the right at all times to discontinue or modify the Terms and/or our Privacy Policy as and when we deem necessary or desirable. Upon such discontinuance or modification of the Terms and/or our Privacy Policy, the user registered on this website/App as a member shall be notified via their registered email. Your continued use of this site/App after such modifications being notified to you will constitute acknowledgment and agreement of the modified Terms and/or our Privacy Policy.</p>

<p><strong>Miscellaneous terms</strong></p>

<p>While BeWise makes every effort to ensure that the material on this website/App is accurate and up-to-date, you should exercise your own independent skill and judgement before you rely on it. This website/App is not a substitute for independent professional advice and users should obtain any appropriate professional advice relevant to their particular circumstances.</p>

<p>You obtain access to this website/App at your own risk and BeWise accepts no responsibility for any interference, loss, damage or disruption to your own computer system which arises in connection with your use of this website/App or any linked website. You must take your own precautions to ensure that the process which you employ to obtain access to this website/App does not expose you to the risk of viruses, malicious computer code or other forms of interference which may damage your own computer system.</p>

<p><strong>Cessation</strong></p>

<p>Without limiting the foregoing, we shall have the right to freeze/ discontinue/ delete the account of the user in the event of any conduct by the user, including, but not limited to prohibited acts as listed under the part &lsquo;Prohibited usage&rsquo; in this Agreement, which we, in our sole discretion, consider to be unacceptable, or in the event of any breach by the user of this Agreement. Any such cessation of this Agreement shall not cancel your obligation or affect any liability that may have arisen under this Agreement.</p>

<p><strong>Severability</strong></p>

<p>If any part of the Terms and/or Privacy Policy are determined to be invalid or unenforceable pursuant to applicable laws of India, including, but not limited to, the liability limitations and warranty disclaimers set forth above, then the invalid or unenforceable provision will be deemed to be superseded by a valid, enforceable provision that most closely matches the intent of the original provision and the remainder of the Terms and/or Privacy Policy shall continue to be in effect.</p>

<p><strong>Entire Agreement</strong></p>

<p>Unless otherwise specified herein, this Agreement constitutes the entire agreement between you and BeWise and supersedes all previous written and oral agreements between you and BeWise, if any. BeWise&rsquo;s failure to act with respect to a breach by you or others does not waive its right to act with respect to subsequent or similar breaches.</p>

<p><strong>Dispute resolution and jurisdiction</strong></p>

<p>If you choose to visit this website/App, your visit and any dispute over data privacy is subject to this Agreement. In addition to the foregoing, any disputes arising under these Terms shall be governed by the laws of India and the courts of Karnataka shall have exclusive jurisdiction in determining such dispute.</p>

<p>In case of a dispute, the matter will first be attempted to be resolved by way of mediation by a sole mediator who is a neutral third party and will be selected at the mutual acceptance of a proposed mediator by both parties. Both parties may raise a name for sole mediator and in the case both parties accept the proposed name, the said person shall be appointed sole mediator. In case the parties are not able to reach a consensus within two proposed mediators, the Company reserves the right to decide who the final mediator is. The parties in good faith will attempt to bind by the decision.</p>

<p><strong>Contact Information</strong></p>

<p className="termscond_para">Questions about the Terms should be sent to us at <a href="mailto:contact@bewise.in">contact@bewise.in</a>.</p>

        </div>
      </React.Fragment>
    );
  }
}
class PrivacyPolicies extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentDidMount() {
  }
  render() {
    return (
      <React.Fragment>
        <div className="privacy-page">
          <p>
            BeWise recognizes the importance of maintaining your privacy. We value your
            privacy and appreciate your trust in us. This privacy policy is being
            published in accordance with the provisions of the applicable provisions of
            laws in India.
          </p>
          <p>
            This policy describes how we treat user information we collect on the Device
            Support Application (“App”)/ website (named BeWise.in). This Privacy Policy
            applies to current and former visitors to our App/ website. By visiting and/or
            using our App/ website, you agree to this Privacy Policy.
          </p>
          <p>This privacy policy was updated in September, 2020.</p>
          <h5>1. General</h5>
          <p>
            For the purpose of this Privacy Policy, wherever the context so requires,
            ‘you’ or ‘user’ shall mean any natural or legal person who uses our
            App/website, browses our website or becomes a member of our website by signing
            up on BeWise as a user. BeWise allows the user to surf this website without
            signing up on this website. The term “we”, “us”, “our” shall mean BeWise and
            the term ‘site’ or ‘website’ refers to{" "}
            <a href="www.bewise.in">www.BeWise.in</a>.
          </p>
          <h5>2. Information we collect</h5>
          <p>
            Depending on your interaction with us (meaning, if you are just browsing our
            website, or if you have signed up on this website, etc.), we may collect two
            types of information from you, i.e. ‘Personal Information’ and ‘Non-Personal
            Information’.
          </p>
          <h6>a) Personal Information</h6>
          <p>
            Personal Information is the information that identifies a specific ‘End User’.
            When you engage in certain activities on this website/App, such as signing up,
            posting a review, rating a partner or any other third party listed on
            our website/App, requesting information about our services or the services of
            the third party partners listed on our website/App (collectively,
            “Activities”), we may ask you to provide certain information about yourself or
            your ward. It is optional for you to engage in an Activity. If you elect to
            engage in an Activity, we may ask you to provide us with certain personal
            information about yourself, such as your first and last name, email address,
            telephone number, child’s name, age, etc. BeWise allows the user to sign up on
            this website using social networking sites such as Facebook, Instagram, Google
            accounts and LinkedIn, whereby, the user’s data may be shared by such social
            networking sites with us.
          </p>
          <p>
            Depending on the activity, some of the information we ask you to provide is
            identified as mandatory and some is identified as voluntary. If you do not
            provide the mandatory information for a particular activity that requires it,
            you will not be permitted to engage in that activity.
          </p>
          <p>
            We use Personal Information to enhance the operation of this website/App,
            improve our marketing and promotional efforts, analyze website/App use,
            improve our listings on the website/App, to personalize your experience and to
            understand how our users, as a whole, use the services and resources provided
            on our site/App and to provide you a better experience.
          </p>
          <p>
            In addition to this, your Personal Information may be used to troubleshoot,
            resolve disputes, accomplish administrative tasks, contact you, enforce our
            agreements with you, including our website Terms and Conditions and this
            Privacy Policy, comply with applicable law, and cooperate with law enforcement
            activities.
          </p>
          <h6>b) Non-Personal Information</h6>
          <p>
            Non-Personal Information is the information that does not identify a specific
            End User. This type of information may include things like the Uniform
            Resource Locator (“URL”) of the website you visited before coming to our
            website, the URL of the website you visit after leaving our website, the type
            of browser you are using and your Internet Protocol (“IP”) address.
          </p>
          <p>
            We use Non-Personal Information to troubleshoot, administer this website/App,
            analyze trends, gather demographic information, comply with applicable law,
            and cooperate with law enforcement activities.
          </p>
          <h6>3. Utilising user’s information</h6>
          <p>
            The information/data collected is used for the purposes of understanding the
            user along with the location the user is from through geolocation platform, to
            analyse our audience. Collecting this data helps us understand what you are
            looking from the company, enabling us to deliver improved services.
          </p>
          <p>We may use your data for the following general purposes:</p>
          <ul>
            <li> To contact you in response to a specific enquiry</li>
            <li> To improve the services that we provide</li>
            <li> To customise the website/App for you</li>
            <li> For our internal records</li>
            <li>
              To send you promotional emails about products, services, offers and other
              things we think might be relevant to you.
            </li>
            <li>
              To contact you via email, telephone or mail for market research reasons.
            </li>
          </ul>
          <h5>4. Release of user’s information</h5>
          <p>
            We may disclose your information to other entities within BeWise’s company
            group and its partners, for legitimate business purposes (including
            operating the services, and providing services to you), in accordance with
            applicable law. We may also disclose your information to any relevant
            third-party partners listed on our website/App such as /preschools/
            after school activity centers/schools/tuition centres/community support
            centres, etc. for the purpose of providing appropriate services to you as per
            your request.
          </p>
          <p>
            We will not sell, trade, distribute or lease your personal information to
            third parties unless we have your permission or if required to do so by law or
            in the good faith belief that such disclosure is reasonably necessary to
            respond to court orders or other legal process.
          </p>
          <h5>5. Security</h5>
          <p>
            We are committed to ensuring that your information is secure, but please note
            that no method of transmission over the internet, or method of electronic
            storage, is 100% secure. However, we will always hold your information
            securely and prevent unauthorised disclosure or access to your information.
            Further, by providing your information you allow us to share your information
            with our partner brands/partners for their promotional purposes.
          </p>
          <p>
            For general web browsing, no Personal Information is revealed to us, although
            certain statistical information is available to us via our internet service
            provider. This information may include the logical address of the server you
            are using, the top level domain name from which you access the internet (for
            example, .com, .in, etc.), the type of browser you are using, the date and
            time you access our site and the internet address used to link to our site.
          </p>
          <p>
            Some of the above information is used to create summary statistics, which
            allow us to assess the number of visitors to our site and to identify what
            pages of our site are accessed most frequently. We use these statistics to
            help us make our site more user friendly.
          </p>
          <h5>6. Miscellaneous Privacy Issues</h5>
          <p>
            This website/App is not meant to be used directly by children/minors under the
            age of 18, and/or any person who is not capable of entering into a binding
            contract. We do not collect or maintain information from anyone known to be
            under the age of 18, unless such information has been lawfully provided by the
            parents or guardians of the children and no part of this website/App is
            designed to directly attract anyone under the age of 18 and/or any person who
            is not capable of entering into a binding contract. If you are under 18, or
            are not capable of entering into a binding contract, and still want to use
            this website/App, you may use BeWise only with the involvement of a parent or
            guardian.
          </p>
          <p>We do not share, transfer, sell or trade children's information.</p>
          <p>
            We may provide areas on our website/App where you can publicly post
            information about yourself and provide reviews and ratings for the individual
            and institutional partners listed on our website/App. This
            information may be accessible by other users and may appear on other websites
            or web searches, and therefore this information is not confidential and could
            be read, collected, and used by others.
          </p>
          <h5>7. Links to external sites</h5>
          <p>
            Information on our website/App may include some links which may lead to other
            websites, including those operated and maintained by third parties or such
            other third-party sites that might be directly or indirectly related to the
            individual or institutional partners listed on our website/App.
            BeWise includes these links solely as a convenience to you and the presence of
            such a link does not imply a responsibility on BeWise for the linked site or
            an endorsement of the linked site, its operator, or its contents.
          </p>
          <p>
            Please be aware that once you click on the link to one of these sites, you
            will be subject to that site's privacy policy and not to ours. We recommend
            that you examine each website's Privacy Policy separately.
          </p>
          <p>
            Apart from this website/App, the users may contact/ connect with BeWise using
            social networking services such as Facebook, Twitter, LinkedIn and Instagram.
            When you connect with us using these services, we may collect your personal
            information to communicate with you. The social networking service will also
            handle your personal information for its own purposes. These social networking
            services have their own privacy policies. You can access the privacy policies
            for these social networking services on their respective websites.
          </p>
          <h5>8. Cookies</h5>
          <p>
            This website uses “cookie” technology. A cookie is a small piece of data or a
            small text file stored by the browser on your computer, at the request of our
            server. We may use cookies to deliver content specific to your interests and
            to save your personal preferences so you do not have to re- enter them each
            time you connect to our website – our cookies are not available to other
            websites. In particular cookies enable us:
          </p>
          <ul className="list-dot">
            <li>to measure visitor traffic to our website and their usage patterns</li>
            <li>to identify whether you are signed in to our website</li>
            <li>
              to test content on our website and pattern of a user on the website. For
              instance, 50% of our users might see one piece of content, the other 50% a
              different piece of content.
            </li>
            <li>
              to store information about your preferences and so allow us to customize our
              website according to your individual interests
            </li>
            <li>to speed up your searches</li>
            <li>to recognize you when you return to our website</li>
          </ul>
          <p>
            You are always free to decline such cookies, if your browser permits, or to
            ask your browser to indicate when a cookie is being sent. You can also delete
            cookie files from your computer at your discretion. However, please note that
            doing this may affect how our website functions. Some pages and services may
            become unavailable to you.
          </p>
          <p>
            To learn more about cookies and how they are used, visit{" "}
            <a href="http://www.allaboutcookies.org/">http://www.allaboutcookies.org/</a>.
          </p>
          <h5>9. Advertising cookies</h5>
          <p>
            Some of the advertisements you see on BeWise are provided by other
            organizations. These organizations can use their own anonymous cookies to
            track how many people have seen a particular ad, or to track how many people
            have seen it more than once.
          </p>
          <p>
            The entities that generate these cookies have their own privacy policies, and
            we have no access to read or write these cookies. These organizations may use
            their cookies to anonymously target advertising to you on other websites,
            based on your visit to BeWise.
          </p>
          <h5>10. Electronic communication</h5>
          <p>
            There are inherent risks associated with the transmission of information over
            the internet, including via email. You should be aware of this when sending
            your personal information to us via email or via our website/App or social
            media platforms. If this is of concern to you then you may use other methods
            of communication with us, such as post or telephone (although these also have
            risks associated with them).
          </p>
          <h5>11. Changes to this privacy policy</h5>
          <p>
            Please note that the privacy policy may change from time to time. BeWise
            reserves the right to change this policy at any time. The users registered on
            this website/App as a member shall be notified of the changes or
            modifications, if any, done on this policy via their registered email by
            BeWise.
          </p>
          <h5>12. Your Acceptance of these terms</h5>
          <p>
            By using this website/App, you signify your acceptance of our privacy policy.
            If you do not agree to this policy, please do not use our website/App. Your
            continued use of this website/App following the posting of changes to this
            policy, as and when notified to you, will be deemed your acceptance of those
            changes.
          </p>
          <h5>13. Jurisdiction</h5>
          <p>
            If you choose to visit this website/App, your visit and any dispute over data
            privacy is subject to this policy and the terms and conditions of this
            website/App. In addition to the foregoing, any disputes arising under this
            policy shall be governed by the laws of India and the courts of Karnataka
            shall have exclusive jurisdiction in determining such dispute.
          </p>
          <h5>14. Complaints</h5>
          <p>
            If you think BeWise may have breached your privacy, you may contact us to make
            a complaint and rectify our actions. In order to ensure that we fully
            understand the nature of your complaint and the outcome you are seeking, we
            prefer that you make your complaint in writing via email to the below
            mentioned email address.
          </p>
          <p>
            Further, in accordance with Information Technology Act, 2000 and rules made
            thereunder, the name and contact details of the grievance officer who can be
            contacted with respect to any complaints or concerns including those
            pertaining to breach of BeWise’s Terms & Conditions, and other polices or
            questions are published as under:
          </p>
          <p>
            Name: Sethuraman
            <br />
            Email Address: <a href="mailto:contact@bewise.in">contact@bewise.in</a>
          </p>
        </div>
      </React.Fragment>
    );
  }
}
const locations = [{"id":27,"location":"Hosur","latitude":"12.7409","longitude":"77.8253","status":1,"sort_order":4},{"id":1,"location":"Bengaluru","latitude":"12.9716","longitude":"77.5946","status":1,"sort_order":1},{"id":12,"location":"Chennai","latitude":"13.0569","longitude":"80.2425","status":1,"sort_order":2},{"id":11,"location":"Coimbatore","latitude":"11.0168","longitude":"76.9558","status":1,"sort_order":3},{"id":2,"location":"Hyderabad","latitude":"17.3850","longitude":"78.4867","status":1,"sort_order":4},{"id":24,"location":"Madurai","latitude":"9.9252","longitude":"78.1198","status":1,"sort_order":5},{"id":13,"location":"Mumbai","latitude":"19.0760","longitude":"72.8777","status":1,"sort_order":7},{"id":15,"location":"Kolkata","latitude":"22.5726","longitude":"88.3639","status":1,"sort_order":8},{"id":16,"location":"New Delhi","latitude":"28.6139","longitude":"77.2090","status":1,"sort_order":9},{"id":17,"location":"Jaipur","latitude":"26.9124","longitude":"75.7873","status":1,"sort_order":10},{"id":18,"location":"Chandigarh","latitude":"30.7333","longitude":"76.7794","status":1,"sort_order":11},{"id":19,"location":"Pune","latitude":"18.5204","longitude":"73.8567","status":1,"sort_order":12},{"id":20,"location":"Kochi","latitude":"9.9312","longitude":"76.2673","status":1,"sort_order":13},{"id":21,"location":"Noida","latitude":"28.5355","longitude":"77.3910","status":1,"sort_order":14},{"id":22,"location":"Agra","latitude":"27.1767","longitude":"78.0081","status":1,"sort_order":15},{"id":23,"location":"Puducherry","latitude":"11.9416","longitude":"79.8083","status":1,"sort_order":16},{"id":25,"location":"Tiruchirappalli","latitude":"10.7905","longitude":"78.7047","status":1,"sort_order":17}];
class BottomMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: false,
      sidemenu: false,
      showCityPop:false,
      showMenuPop:false,
      openProfile: false,
      mobLocationToggle: false,
      chatopen: false,
      signin: false,
      page_menu: this.props.page_menu ? this.props.page_menu : [],
      user_name: '',
      login_type_name: '',
      showDefaultMenuPop:false,
      active_menu: '',
      location_list: locations
    };
    this.selectedCity = (localStorage.getItem('current_location')==null)?'Bengaluru':localStorage.getItem('current_location').toLowerCase();
    console.log("selected city", this.selectedCity);
    this.toggle = this.toggle.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    //this.LocationDataList();
  }
  componentDidMount() {
    let auth_data = (localStorage.getItem("myData"));
    if (auth_data) {
      auth_data = JSON.parse(auth_data);
      let login_type_name = '';
      if (auth_data.login_type == 2) {
        login_type_name = 'Google';
      } else if (auth_data.login_type == 3) {
        login_type_name = 'Facebook';
      } else if (auth_data.login_type == 4) {
        login_type_name = 'LinkedIn';
      }
      console.log('auth_data', auth_data)
      this.setState({
        user_name: auth_data.first_name + ' ' + auth_data.last_name,
        auth: true,
        user_id: auth_data.user_id,
        login_type: auth_data.login_type,
        login_type_name: login_type_name
      });
    }


  }
  componentWillReceiveProps() {
    this.setState({
      sidemenu: false,
      signin: false,
    })
    console.log('props came')
    if ($("#chatbotblock").hasClass("hidden")) {
      console.log('chatclode')
      this.setState({
        chatopen: false
      });
    }
  }
  componentDidUpdate() {
    //window.jQuery('.selectpicker').selectpicker('refresh');
    let THIS = this;
    if ($("#chatbotblock").hasClass("hidden")) {
      // console.log('chatclode')
      // THIS.setState({
      //   chatopen: false
      // });
    }

  }
  setChat = (e) => {
    $("#chatbotblock").removeClass('hidden');
    this.setState({
      openProfile: false,
      sidemenu: false,
      signin: false,
      mobLocationToggle: false,
      mobLocationToggle: false,
      chatopen: true,
    });
  };
  toggleProfileMenu = () => {
    $("#chatbotblock").addClass('hidden');
    this.setState({
      openProfile: !this.state.openProfile,
      sidemenu: false,
      signin: false,
      mobLocationToggle: false,
      chatopen: false,
    })
  }
  openSideMenu = () => {
    $("#chatbotblock").addClass('hidden');
    this.setState({
      sidemenu: true,
      signin: false,
      openProfile: false,
      mobLocationToggle: false,
      chatopen: false,
    })
  }
  mbLocToogle = () => {
    $("#chatbotblock").addClass('hidden');
    $(".menudropdown").addClass('hidden');
    $(".acd").toggleClass('hidden');
    this.setState({
      mobLocationToggle: !this.state.mobLocationToggle,
      openProfile: false,
      sidemenu: false,
      signin: false,
      chatopen: false,
    });
  }
  openSignin = () => {
    $("#chatbotblock").addClass('hidden');
    this.setState({
      mobLocationToggle: false,
      sidemenu: false,
      signin: true,
      openProfile: false,
      chatopen: false,
    });
  }
  closeRightMenu = () => {
    $("#chatbotblock").addClass('hidden');
    this.setState({
      mobLocationToggle: false,
      sidemenu: false,
      signin: false,
      openProfile: false,
      chatopen: false,
    });
  }

  showCityPopup = () =>{

      $("#chatbotblock").addClass('hidden');
      $(".menudropdown").addClass('hidden');
      this.setState({
        openProfile: false,
        sidemenu: false,
        signin: false,
        chatopen: false,
      });

      this.setState({showCityPop:true,showMenuPop:false, showDefaultMenuPop:false, mobLocationToggle:true});

  }

  showDefaultMenuPopup = () =>{
    
    $("#chatbotblock").addClass('hidden');
    $(".menudropdown").toggleClass('hidden');
    this.setState({
      openProfile: false,
      sidemenu: false,
      signin: false,
      chatopen: false,
    });

    this.setState({showCityPop:false,showMenuPop:false, showDefaultMenuPop:true, mobLocationToggle:false});

}

  showMenuPopup = () =>{
      this.setState({showMenuPop:true, showDefaultMenuPop:false});
  }

  changeCity = (cityselected) =>{

      localStorage.setItem('current_location', cityselected);
      //alert(cityselected);
      // alert(e.target.value)
      let current_location = cityselected;
      //alert(current_location);
      if(current_location == 'bengaluru' || current_location == 'chennai' || current_location == 'hosur')
      {
       this.setState({showCityPop:false});
       this.setState({
        current_location: cityselected,
        current_locations: cityselected,
      });
      let check_location = this.state.location_list.filter(o => o.location.toUpperCase() == current_location.toUpperCase());
      localStorage.setItem("current_location", current_location);
      let lat = check_location[0].latitude;
      let lng = check_location[0].longitude;
      localStorage.setItem("latitude", lat);
      localStorage.setItem("longitude", lng);
      var urltoredirect = window.location.href;
      //alert(urltoredirect);
      const urlparts = urltoredirect.split("/");
      //console.log(urlparts);
      if (urlparts[4] == 'schools' || urlparts[4] == 'pre-schools' || urlparts[4] == 'kids-play-area' || urlparts[4] == 'learning-camps' || urlparts[4] == 'community-support' || urlparts[4] == 'birthday-event' || urlparts[4] == 'tuitions' || urlparts[4] == 'after-school-activity') {        let makeurl = BASE_URL + current_location.toLowerCase() + "/" + urlparts[4];
        if (urlparts[5] !== undefined) {
          makeurl = makeurl + "/" + urlparts[5];
        }
        //alert(makeurl);
        window.location.href = makeurl;
      }
      else
        window.location.reload();


      }else{
        this.setState({
          showLocationPop: true
        })
        alert("coming soon")
      }

  }

     
  closeCityPopup = () =>{
      this.setState({showCityPop:false});
  }

  toggle() {
    this.setState({
      showCityPop: !this.state.showCityPop
    });
  }

  toggleMenu(){
    this.setState({
      showMenuPop: !this.state.showMenuPop
    });
  }

  render() {
    let path = window.location.pathname, isHome = false, active_menu = this.state.active_menu;
    const { auth, user_name, mobLocationToggle, sidemenu, openProfile, chatopen,showDefaultMenuPop, showCityPop, showMenuPop} = this.state;

    const current_location = localStorage.getItem('current_location');
    
    if (path == '/') {
      isHome = true;
      active_menu = 'home';
    }
    else
      isHome = false;

    if (showCityPop)
      active_menu = 'location';
    if (sidemenu)
      active_menu = 'sidemenu';
    if (showMenuPop)
      active_menu = 'menu';
    if(showDefaultMenuPop)
      active_menu = 'newmenu'
    if (openProfile)
      active_menu = 'profile';
    if (chatopen)
      active_menu = 'chat';
    return (
      <React.Fragment>


        <Modal isOpen={this.state.showCityPop} id="citypopup"  modalTransition={{ timeout: 700 }} backdropTransition={{ timeout: 1300 }}
          toggle={this.toggle} centered size='lg'>
          <ModalBody className='p-0'>
            
            <div class='citypopupinnerblock'>
                <div class="cityhead"><i class="fa fa-map-marker" aria-hidden="true">&nbsp;</i><h6>choose city</h6></div>
                <ul>
                  <li  onClick={()=> this.changeCity('bengaluru')} className={this.selectedCity=='bengaluru'?'active':''}>Bengaluru</li>
                  <li  onClick={()=> this.changeCity('chennai')} className={this.selectedCity=='chennai'?'active':''}>Chennai</li>
                  <li  onClick={()=> this.changeCity('hosur')} className={this.selectedCity=='hosur'?'active':''}>Hosur</li>
                  <li  onClick={()=> this.changeCity('coimbatore')} className={this.selectedCity=='coimbatore'?'active':''}>Coimbatore</li>
                  <li  onClick={()=> this.changeCity('hyderabad')} className={this.selectedCity=='hyderabad'?'active':''}>Hyderabad</li>
                  <li  onClick={()=> this.changeCity('madurai')} className={this.selectedCity=='madurai'?'active':''}>Madurai</li>
                  <li  onClick={()=> this.changeCity('mumbai')} className={this.selectedCity=='mumbai'?'active':''}>Mumbai</li>
                  <li  onClick={()=> this.changeCity('kolkata')} className={this.selectedCity=='kolkata'?'active':''}>Kolkata</li>
                  <li  onClick={()=> this.changeCity('new delhi')} className={this.selectedCity=='new delhi'?'active':''}>New Delhi</li>
                  <li  onClick={()=> this.changeCity('jaipur')} className={this.selectedCity=='jaipur'?'active':''}>Jaipur</li>
                  <li  onClick={()=> this.changeCity('chandigarh')} className={this.selectedCity=='chandigarh'?'active':''}>Chandigarh</li>
                  <li  onClick={()=> this.changeCity('pune')} className={this.selectedCity=='pune'?'active':''}>Pune</li>
                  <li  onClick={()=> this.changeCity('kochi')} className={this.selectedCity=='kochi'?'active':''}>Kochi</li>
                  <li  onClick={()=> this.changeCity('noida')} className={this.selectedCity=='noida'?'active':''}>Noida</li>
                  <li  onClick={()=> this.changeCity('agra')} className={this.selectedCity=='agra'?'active':''}>Agra</li>
                  <li  onClick={()=> this.changeCity('puducherry')} className={this.selectedCity=='puducherry'?'active':''}>Puducherry</li>
                  <li  onClick={()=> this.changeCity('tiruchirappalli')} className={this.selectedCity=='tiruchirappalli'?'active':''}>Tiruchirappalli</li>
                </ul>
            </div>
            <div class='citypopupinnerblock text-center hidden' onClick={this.closeCityPopup}>Close</div>
          </ModalBody>
        </Modal>

        <Modal isOpen={this.state.showMenuPop} id="menupopup"  modalTransition={{ timeout: 700 }} backdropTransition={{ timeout: 1300 }}
          toggle={this.toggleMenu} centered size='lg'>
          <ModalBody className='p-0'>
            
            <div class='menupopupinnerblock'>
              <div class="wrapper">
              <ul class="mainMenu">
                  <li class="item" id="account">
                      <a href="#account" class="btnm"><i class="fas fa-user-circle"></i>My Account +</a>
                      <div class="subMenu">
                          <a href='/edit_profile'>Edit Profile</a>
                          <a href='/wishlist'>Wishlist</a>
                          <a href='/compare-list'>Compare</a>

                      </div>
                  </li>
                  <li class="item" id="about">
                      <a href="#about" class="btnm"><i class="fas fa-address-card"></i>Pages</a>
                      <div class="subMenu">
                         <MainmenuMobile />
                      </div>
                  </li>
                  
                  <li class="item">
                      <a href="#" onClick={(e) => logout(e)} class="btnm"><i class="fas fa-sign-out-alt"></i>Log Out</a>
                  </li>
              </ul>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <div className='newuifooter footer-bottom-menu row'>
                    
          <div className=' bottom-menu  col-12'>
            <div className='tab-nav-container col-12'>

              { /* <div className={active_menu == 'sidemenu' ? 'active tab' : 'tab'}>
                <a href='javascript:;' onClick={this.openSideMenu}>
                  <img src={active_menu == 'sidemenu' ? '/assets/images/bottom-menu/btm-mn-blue-list.png' :
                    '/assets/images/bottom-menu/btm-mn-list.png'} />
                  <span><small>Menu</small></span>
                </a>
              </div>  onClick={this.showMenuPopup} */ }

               <div className={active_menu == 'newmenu' ? 'active tab' : 'tab'}  >
                              

                <a class="menuclss" onClick={this.showDefaultMenuPopup} href="#">
                  <img src={active_menu == 'newmenu' ? '/assets/images/bottom-menu/btm-mn-blue-list.png' :
                    '/assets/images/bottom-menu/btm-mn-list.png'
                  }  id="Popover1" alt="bottommenu" width={"50px"} height={"50px"}/>
                  <span><small>Menu</small></span>
                </a>

                <MainmenuMobileV2 />

               

              </div>
              
              <div className={active_menu == 'location' ? 'active tab' : 'tab'}>
                <a onClick={this.showCityPopup} href="#">
                  <img src={active_menu == 'location' ? '/assets/images/bottom-menu/btm-mn-blue-location.png' :
                    '/assets/images/bottom-menu/btm-mn-location.png'
                  }  id="Popover2" alt="bottommenu" width={"50px"} height={"50px"}/>
                  <span><small>Location</small></span>
                </a>
              </div>

              {auth ? (
                <React.Fragment>
                  <div className={active_menu == 'profile' ? 'active tab' : 'tab'}>
                    <a href='javascript:;'>
                      <img src=
                        {active_menu == 'profile' ? '/assets/images/bottom-menu/btm-mn-blue-profile.png' :
                          '/assets/images/bottom-menu/btm-mn-profile.png'
                        } onClick={this.toggleProfileMenu} id="Popover-usermenu1" alt="bottommenu"/>
                      <span><small>Profile</small></span>
                    </a>
                  </div>
                  <Popover className='filter-pop-over bottom-prof-pop-over' placement="bottom-end" trigger="focus"
                    isOpen={this.state.openProfile} target="Popover-usermenu1" toggle={this.toggleProfileMenu}>
                    {/* <PopoverHeader>
                      {user_name}
                      {this.state.login_type_name && <p className='mb-0'><small>logged in through {this.state.login_type_name}</small></p>}
                    </PopoverHeader> */}
                    <PopoverBody className>
                      <div className='row'>
                        <div className='col-12 btm-menu-link'>
                          <a href='/edit_profile'>
                            Edit Profile
                          </a>
                        </div>
                        <div className='col-12 btm-menu-link'>
                          <a href='/wishlist'>
                            Wishlist
                          </a>
                        </div>
                        <div className='col-12 btm-menu-link'>
                          <a href='/compare-list'>
                            Compare
                          </a>
                        </div>
                        <div className='col-12 btm-menu-link'>
                          <a href='javascript:;' onClick={(e) => logout(e)}>
                            Logout
                          </a>
                        </div>
                      </div>
                    </PopoverBody>
                  </Popover>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className='tab' onClick={this.openSignin} >
                    <a href='javascript:;'>
                    <img
                    src={active_menu == 'chat' ? '/assets/images/bottom-menu/login.png' :
                      '/assets/images/bottom-menu/login.png'} alt="bottommenu" width={"50px"} height={"50px"}/>

                    <span><small>Sign In</small></span>
                    </a>
                  </div>
                </React.Fragment>
              )}
              
              <div className={active_menu == 'chat' ? 'active tab' : 'tab'}>
                <a href='javascript:;' onClick={this.setChat} >
                  <img
                    src={active_menu == 'chat' ? '/assets/images/bottom-menu/btm-mn-blue-chatbot.png' :
                      '/assets/images/bottom-menu/btm-mn-chatbot.png'} alt="bottommenu" width={"50px"} height={"50px"}/>
                  <span><small>Chat Support</small></span>
                </a>
              </div>

              {!isHome && 
              <div className={active_menu == 'home' ? 'active tab' : 'tab'}>
                <a href='/'>
                  <img src={active_menu == 'home' ? '/assets/images/bottom-menu/btm-mn-blue-home.png' :
                    '/assets/images/bottom-menu/btm-mn-home.png'
                  } alt="bottommenu" width={"50px"} height={"50px"}/>
                  <span><small>Home</small></span>
                </a>
              </div>
              }
              
            </div>
            <RightMenuMobile sidemenu={this.state.sidemenu} page_menu={this.state.page_menu} onCloseMenu={this.closeRightMenu} />
            <Newlogin login={this.state.signin} />
          </div>

        </div>
        
      </React.Fragment>
    );
  }
  LocationDataList = async () => {
    try {
      const res = await LocationData();
      if (res.status == 1) {
        this.setState({
          location_list: res.results,
          error: false
        });
      }

    } catch (error) {
      this.setState({ error: true });
    }
  };
  locationList = (currentlocation) => {
    let locate = this.state.location_list !== undefined ? this.state.location_list : [];

    console.log('locate', locate)
 
    let rows = "";
    if (locate.length > 0) {
      rows = locate.map((locate, index) => {
        if(currentlocation==locate.location){
        return (
          <option key={index} value={locate.location} selected>{locate.location}</option>
        );
        }else{
        return (
          <option key={index} value={locate.location}>{locate.location}</option>
        );
        }
      });

    } else {
      rows = "";
    }
    return rows;
  }
  handlechange_location = (e) => {
    // alert(e.target.value)
    let current_location = e.target.value;
    if ((current_location != 'Bengaluru' && current_location != 'Chennai' && current_location != 'Hosur')) {
      this.setState({
        showLocationPop: true
      })
    } else {
      this.setState({
        current_location: e.target.value,
        current_locations: e.target.value,
      });
      let check_location = this.state.location_list.filter(o => o.location == current_location);
      localStorage.setItem("current_location", current_location);
      let lat = check_location[0].latitude;
      let lng = check_location[0].longitude;
      localStorage.setItem("latitude", lat);
      localStorage.setItem("longitude", lng);
      var urltoredirect = window.location.href;
      //alert(urltoredirect);
      const urlparts = urltoredirect.split("/");
      //console.log(urlparts);
      if (urlparts[4] == 'schools' || urlparts[4] == 'pre-schools' || urlparts[4] == 'kids-play-area' || urlparts[4] == 'learning-camps' || urlparts[4] == 'community-support' || urlparts[4] == 'birthday-event' || urlparts[4] == 'tuitions' || urlparts[4] == 'after-school-activity') {
        let makeurl = BASE_URL + current_location.toLowerCase() + "/" + urlparts[4];
        if (urlparts[5] !== undefined) {
          makeurl = makeurl + "/" + urlparts[5];
        }
        //alert(makeurl);
        window.location.href = makeurl;
      }
      else
        window.location.reload();
    }

  }
}

const menumobile = [{"category_name":"Pre-Schools","slug_term":"pre-schools","subdata":[{"category_name":"Montessori","slug_term":"montessori"},{"category_name":"Kindergarten","slug_term":"kindergarten"},{"category_name":"Play Group","slug_term":"play-group"},{"category_name":"Special Needs","slug_term":"special-needs"},{"category_name":"Day care or Creche","slug_term":"day-care-or-creche"}]},{"category_name":"Schools","slug_term":"schools","subdata":[{"category_name":"Private School","slug_term":"private-schools"},{"category_name":"Public School","slug_term":"public-schools"},{"category_name":"Boarding School","slug_term":"boarding-schools"},{"category_name":"International School","slug_term":"international-schools"},{"category_name":"Special Needs","slug_term":"school-special-needs"},{"category_name":"Alternative School","slug_term":"alternative-schools"},{"category_name":"Open School","slug_term":"open-schools"},{"category_name":"E-School","slug_term":"e-schools"}]},{"category_name":"Kids Play Areas","slug_term":"kids-play-area","subdata":[{"category_name":"Indoor","slug_term":"indoor"},{"category_name":"Outdoor","slug_term":"outdoor"}]},{"category_name":"After School Activity","slug_term":"after-school-activity","subdata":[{"category_name":"Sports","slug_term":"sports"},{"category_name":"Music","slug_term":"music"},{"category_name":"Dance and Theatre","slug_term":"dance-and-theatre"},{"category_name":"Creative Arts","slug_term":"creative-arts"},{"category_name":"Mind & Skills Enrichment","slug_term":"mind-and-skill-enrichment"},{"category_name":"Hobbies & Passion","slug_term":"hobbies-and-passion"}]},{"category_name":"Tuitions","slug_term":"tuitions","subdata":[{"category_name":"Maths","slug_term":"maths"},{"category_name":"Science/ EVS","slug_term":"science"},{"category_name":"Economics","slug_term":"economics"},{"category_name":"Business Studies","slug_term":"business-studies"},{"category_name":"Languages","slug_term":"languages"},{"category_name":"Social sciences","slug_term":"social-science"}]},{"category_name":"Learning Camps","slug_term":"learning-camps","subdata":[{"category_name":"Below 4 Years","slug_term":"below-4-years"},{"category_name":"5 - 7 Years","slug_term":"5-7-years"},{"category_name":"8 - 10 Years","slug_term":"8-10-years"},{"category_name":"11 - 12 Years","slug_term":"11-12-years"},{"category_name":"13 - 15 Years","slug_term":"13-15-years"},{"category_name":"BeWise Curated Learning camps","slug_term":"curated-learning-camps"},{"category_name":"Summer Camps","slug_term":"bewise-summer-camps"}]},{"category_name":"Community Support","slug_term":"community-support","subdata":[{"category_name":"Counselor","slug_term":"counselor"},{"category_name":"Articles and Blogs","slug_term":"articles-blogs"},{"category_name":"Growth Partnerships","slug_term":"growth-partnerships-for-you"}]},{"category_name":"Birthday & Events","slug_term":"birthday-event","subdata":[{"category_name":"Venues","slug_term":"venues"},{"category_name":"Bakery or Cake shops","slug_term":"bakery-or-cake-shops"},{"category_name":"Entertainers or MCs","slug_term":"entertainers-or-mcs"},{"category_name":"Party Planners","slug_term":"party-planners"},{"category_name":"Gifts & Supportives","slug_term":"gift-and-supportives"}]}];


class MainmenuMobileV2 extends Component{

 constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      menuList: menumobile,
      current_menuList: [],
      active_category: '',
      active_sub_category: '',
      active_tsub_category: '',
      current_location: localStorage.getItem("current_location") ? localStorage.getItem("current_location") : 'bengaluru',
      sidemenu: false,
      showMenu: false,
      showMainMenu: true,
    };
    //this.getMenu();
    this.getURLData(menumobile);
  }


  componentDidMount(){


        $(".hassubmenu").click(function(){

            $(this).find('i').toggleClass('fa-minus');
            $(".submenu").toggleClass('hidden');

        });

  }


  getMenu = () => {
    commonAPI(JSON.stringify({ url: 'getMenu' })).then(res => {
      if (res.status === 1) {
        this.setState({
          menuList: res.list
        })
        this.getURLData(res.list);
      }
    })
  }



  getURLData = (menuList) => {
    let locaArr = window.location.pathname.split('/');
    locaArr = locaArr.filter(n => n);
    let category = locaArr[1];
    let sub_category = locaArr[2];
    let tsub_category = (locaArr.length === 4 || locaArr.length === 5) ? locaArr[3] : '';
    let carr = menuList.filter(item => item.slug_term == category);
    console.log('carr', tsub_category);
    if (carr.length === 1) {
      carr = carr[0];
      carr.subdata.forEach(function (item, i) {
        if (item.slug_term == sub_category) {
          carr.subdata.splice(i, 1);
          carr.subdata.unshift(item);
        }
      });
      if (tsub_category) {
        commonAPI(JSON.stringify({ url: 'getPmenuBySlug', term: sub_category })).then(res => {
          if (res.status === 1) {
            if (res.list.length > 0) {
              res.list.forEach(function (item, i) {
                if (item.slug_term == tsub_category) {
                  res.list.splice(i, 1);
                  res.list.unshift(item);
                }
              });
              this.setState({
                current_menuList: res.list,
                active_sub_category: sub_category,
                active_category: carr.slug_term,
                active_tsub_category: tsub_category,
                filter_opt: locaArr.length === 5 ? true : false
              })
            } else {
              this.setState({
                current_menuList: carr.subdata,
                active_category: carr.slug_term,
                sidebarOpen: false,
                filter_opt: true
              })
            }
          }
        })
      } else {
        this.setState({
          current_menuList: carr.subdata,
          active_category: carr.slug_term,
          sidebarOpen: false
        })
      }

      let scarr = carr.subdata.filter(item => item.slug_term == sub_category);
      if (scarr.length === 1) {
        scarr = scarr[0];
        this.setState({
          active_sub_category: scarr.slug_term,
        })
      }
    }
  }  
   render() {

    const { menuList, active_category, current_location } = this.state;

    return (
      <React.Fragment>
         
      <ul class="menudropdown hidden">
        {this.state.authe &&
        <li> <a class="dropdown-item hassubmenu" href="javascript:;"><i class="fa fa-user-circle-o" aria-hidden="true"></i> My Account <i class="fa fa-plus" aria-hidden="true"></i></a>
          <ul class="submenu dropdown-menu hidden">
            <li><a class="dropdown-item" href="/edit_profile">Edit Profile</a></li>
            <li><a class="dropdown-item" href="/wishlist">Wishlist</a></li>
            <li><a class="dropdown-item" href="/compare-list">Compare</a></li>
          </ul>
        </li>
        } 

       {menuList.map((item, i) => {
                    let subcat = item.subdata[0].slug_term
                    return (
                       <li>
                          {subcat == 'curated-learning-camps' ?
                            (
                              <a href={`/learning-camps/curated-learning-camps`}
                                class="dropdown-item"><i class="fa fa-list-alt" aria-hidden="true"></i>{item.category_name}</a>
                            ) :
                            (
                              <a href={`/${current_location}/${item.slug_term}/${subcat}`}
                                class="dropdown-item"><i class="fa fa-list-alt" aria-hidden="true"></i>{item.category_name}</a>
                            )}
                      </li>
                    )
        })}

        {this.state.authe &&
        <li><a class="dropdown-item" onClick={(e) => logout(e)}><i class="fa fa-sign-out" aria-hidden="true"></i> Logout </a></li>
        }
      </ul>
         
      </React.Fragment>
      )

  }

}

const menus= [{"category_name":"Pre-Schools","slug_term":"pre-schools","subdata":[{"category_name":"Montessori","slug_term":"montessori"},{"category_name":"Kindergarten","slug_term":"kindergarten"},{"category_name":"Play Group","slug_term":"play-group"},{"category_name":"Special Needs","slug_term":"special-needs"},{"category_name":"Day care or Creche","slug_term":"day-care-or-creche"}]},{"category_name":"Schools","slug_term":"schools","subdata":[{"category_name":"Private School","slug_term":"private-schools"},{"category_name":"Public School","slug_term":"public-schools"},{"category_name":"Boarding School","slug_term":"boarding-schools"},{"category_name":"International School","slug_term":"international-schools"},{"category_name":"Special Needs","slug_term":"school-special-needs"},{"category_name":"Alternative School","slug_term":"alternative-schools"},{"category_name":"Open School","slug_term":"open-schools"},{"category_name":"E-School","slug_term":"e-schools"}]},{"category_name":"Kids Play Areas","slug_term":"kids-play-area","subdata":[{"category_name":"Indoor","slug_term":"indoor"},{"category_name":"Outdoor","slug_term":"outdoor"}]},{"category_name":"After School Activity","slug_term":"after-school-activity","subdata":[{"category_name":"Sports","slug_term":"sports"},{"category_name":"Music","slug_term":"music"},{"category_name":"Dance and Theatre","slug_term":"dance-and-theatre"},{"category_name":"Creative Arts","slug_term":"creative-arts"},{"category_name":"Mind & Skills Enrichment","slug_term":"mind-and-skill-enrichment"},{"category_name":"Hobbies & Passion","slug_term":"hobbies-and-passion"}]},{"category_name":"Tuitions","slug_term":"tuitions","subdata":[{"category_name":"Maths","slug_term":"maths"},{"category_name":"Science/ EVS","slug_term":"science"},{"category_name":"Economics","slug_term":"economics"},{"category_name":"Business Studies","slug_term":"business-studies"},{"category_name":"Languages","slug_term":"languages"},{"category_name":"Social sciences","slug_term":"social-science"}]},{"category_name":"Learning Camps","slug_term":"learning-camps","subdata":[{"category_name":"Below 4 Years","slug_term":"below-4-years"},{"category_name":"5 - 7 Years","slug_term":"5-7-years"},{"category_name":"8 - 10 Years","slug_term":"8-10-years"},{"category_name":"11 - 12 Years","slug_term":"11-12-years"},{"category_name":"13 - 15 Years","slug_term":"13-15-years"},{"category_name":"BeWise Curated Learning camps","slug_term":"curated-learning-camps"},{"category_name":"Summer Camps","slug_term":"bewise-summer-camps"}]},{"category_name":"Community Support","slug_term":"community-support","subdata":[{"category_name":"Counselor","slug_term":"counselor"},{"category_name":"Articles and Blogs","slug_term":"articles-blogs"},{"category_name":"Growth Partnerships","slug_term":"growth-partnerships-for-you"}]},{"category_name":"Birthday & Events","slug_term":"birthday-event","subdata":[{"category_name":"Venues","slug_term":"venues"},{"category_name":"Bakery or Cake shops","slug_term":"bakery-or-cake-shops"},{"category_name":"Entertainers or MCs","slug_term":"entertainers-or-mcs"},{"category_name":"Party Planners","slug_term":"party-planners"},{"category_name":"Gifts & Supportives","slug_term":"gift-and-supportives"}]}];

class MainmenuMobile extends Component{

  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      menuList: menus,
      current_menuList: [],
      active_category: '',
      active_sub_category: '',
      active_tsub_category: '',
      current_location: localStorage.getItem("current_location") ? localStorage.getItem("current_location") : 'bengaluru',
      sidemenu: false,
      showMenu: false,
      showMainMenu: true,
    };
    this.getURLData(menus);
    //this.getMenu();
  }

  componentDidMount() {
  }

  getMenu = () => {
    commonAPI(JSON.stringify({ url: 'getMenu' })).then(res => {
      if (res.status === 1) {
        this.setState({
          menuList: res.list
        })
        this.getURLData(res.list);
      }
    })
  }


  getURLData = (menuList) => {
    let locaArr = window.location.pathname.split('/');
    locaArr = locaArr.filter(n => n);
    let category = locaArr[1];
    let sub_category = locaArr[2];
    let tsub_category = (locaArr.length === 4 || locaArr.length === 5) ? locaArr[3] : '';
    let carr = menuList.filter(item => item.slug_term == category);
    console.log('carr', tsub_category);
    if (carr.length === 1) {
      carr = carr[0];
      carr.subdata.forEach(function (item, i) {
        if (item.slug_term == sub_category) {
          carr.subdata.splice(i, 1);
          carr.subdata.unshift(item);
        }
      });
      if (tsub_category) {
        commonAPI(JSON.stringify({ url: 'getPmenuBySlug', term: sub_category })).then(res => {
          if (res.status === 1) {
            if (res.list.length > 0) {
              res.list.forEach(function (item, i) {
                if (item.slug_term == tsub_category) {
                  res.list.splice(i, 1);
                  res.list.unshift(item);
                }
              });
              this.setState({
                current_menuList: res.list,
                active_sub_category: sub_category,
                active_category: carr.slug_term,
                active_tsub_category: tsub_category,
                filter_opt: locaArr.length === 5 ? true : false
              })
            } else {
              this.setState({
                current_menuList: carr.subdata,
                active_category: carr.slug_term,
                sidebarOpen: false,
                filter_opt: true
              })
            }
          }
        })
      } else {
        this.setState({
          current_menuList: carr.subdata,
          active_category: carr.slug_term,
          sidebarOpen: false
        })
      }

      let scarr = carr.subdata.filter(item => item.slug_term == sub_category);
      if (scarr.length === 1) {
        scarr = scarr[0];
        this.setState({
          active_sub_category: scarr.slug_term,
        })
      }
    }
  }


  render() {
    const { menuList, active_category, current_location } = this.state;
    return (
      <React.Fragment>
         
                  {menuList.map((item, i) => {
                    let subcat = item.subdata[0].slug_term
                    return (
                       <>
                          {subcat == 'curated-learning-camps' ?
                            (
                              <a href={`/learning-camps/curated-learning-camps`}
                                className={active_category == item.slug_term && 'active'}>{item.category_name}</a>
                            ) :
                            (
                              <a href={`/${current_location}/${item.slug_term}/${subcat}`}
                                className={active_category == item.slug_term && 'active'}>{item.category_name}</a>
                            )}
                      </>
                    )
                  })}
         
      </React.Fragment>
      )

  }

}

const menurightmenumobile = [{"category_name":"Pre-Schools","slug_term":"pre-schools","subdata":[{"category_name":"Montessori","slug_term":"montessori"},{"category_name":"Kindergarten","slug_term":"kindergarten"},{"category_name":"Play Group","slug_term":"play-group"},{"category_name":"Special Needs","slug_term":"special-needs"},{"category_name":"Day care or Creche","slug_term":"day-care-or-creche"}]},{"category_name":"Schools","slug_term":"schools","subdata":[{"category_name":"Private School","slug_term":"private-schools"},{"category_name":"Public School","slug_term":"public-schools"},{"category_name":"Boarding School","slug_term":"boarding-schools"},{"category_name":"International School","slug_term":"international-schools"},{"category_name":"Special Needs","slug_term":"school-special-needs"},{"category_name":"Alternative School","slug_term":"alternative-schools"},{"category_name":"Open School","slug_term":"open-schools"},{"category_name":"E-School","slug_term":"e-schools"}]},{"category_name":"Kids Play Areas","slug_term":"kids-play-area","subdata":[{"category_name":"Indoor","slug_term":"indoor"},{"category_name":"Outdoor","slug_term":"outdoor"}]},{"category_name":"After School Activity","slug_term":"after-school-activity","subdata":[{"category_name":"Sports","slug_term":"sports"},{"category_name":"Music","slug_term":"music"},{"category_name":"Dance and Theatre","slug_term":"dance-and-theatre"},{"category_name":"Creative Arts","slug_term":"creative-arts"},{"category_name":"Mind & Skills Enrichment","slug_term":"mind-and-skill-enrichment"},{"category_name":"Hobbies & Passion","slug_term":"hobbies-and-passion"}]},{"category_name":"Tuitions","slug_term":"tuitions","subdata":[{"category_name":"Maths","slug_term":"maths"},{"category_name":"Science/ EVS","slug_term":"science"},{"category_name":"Economics","slug_term":"economics"},{"category_name":"Business Studies","slug_term":"business-studies"},{"category_name":"Languages","slug_term":"languages"},{"category_name":"Social sciences","slug_term":"social-science"}]},{"category_name":"Learning Camps","slug_term":"learning-camps","subdata":[{"category_name":"Below 4 Years","slug_term":"below-4-years"},{"category_name":"5 - 7 Years","slug_term":"5-7-years"},{"category_name":"8 - 10 Years","slug_term":"8-10-years"},{"category_name":"11 - 12 Years","slug_term":"11-12-years"},{"category_name":"13 - 15 Years","slug_term":"13-15-years"},{"category_name":"BeWise Curated Learning camps","slug_term":"curated-learning-camps"},{"category_name":"Summer Camps","slug_term":"bewise-summer-camps"}]},{"category_name":"Community Support","slug_term":"community-support","subdata":[{"category_name":"Counselor","slug_term":"counselor"},{"category_name":"Articles and Blogs","slug_term":"articles-blogs"},{"category_name":"Growth Partnerships","slug_term":"growth-partnerships-for-you"}]},{"category_name":"Birthday & Events","slug_term":"birthday-event","subdata":[{"category_name":"Venues","slug_term":"venues"},{"category_name":"Bakery or Cake shops","slug_term":"bakery-or-cake-shops"},{"category_name":"Entertainers or MCs","slug_term":"entertainers-or-mcs"},{"category_name":"Party Planners","slug_term":"party-planners"},{"category_name":"Gifts & Supportives","slug_term":"gift-and-supportives"}]}];


class RightMenuMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      menuList: menurightmenumobile,
      current_menuList: [],
      active_category: '',
      active_sub_category: '',
      active_tsub_category: '',
      current_location: localStorage.getItem("current_location") ? localStorage.getItem("current_location") : 'bengaluru',
      sidemenu: false,
      showMenu: false,
      showMainMenu: true,
    };
    //this.getMenu();
    this.getURLData(menurightmenumobile);
  }
  componentDidMount() {
  }
  componentWillReceiveProps(nextProps) {
    console.log('nextProps.bottom', nextProps)
    if (nextProps.sidemenu === true) {
      this.setState({
        sidebarOpen: true,
      })
    }
  }
  onSetSidebarOpen = (open) => {
    this.setState({ sidebarOpen: open });
    this.props.onCloseMenu();
  }
  scrollToDiv = (e, item) => {
    e.preventDefault();
    $('html,body').animate({
      scrollTop: $(`#${item.link}`).offset().top
    }, 'slow');
    this.setState({ sidebarOpen: false })

  }
  getMenu = () => {
    commonAPI(JSON.stringify({ url: 'getMenu' })).then(res => {
      if (res.status === 1) {
        this.setState({
          menuList: res.list
        })
        this.getURLData(res.list);
        let THIS = this;
        setTimeout(() => {
          THIS.setState({
            update: true
          })
        }, 1000);
      }
    })
  }
  getURLData = (menuList) => {
    let locaArr = window.location.pathname.split('/');
    locaArr = locaArr.filter(n => n);
    let category = locaArr[1];
    let sub_category = locaArr[2];
    let tsub_category = (locaArr.length === 4 || locaArr.length === 5) ? locaArr[3] : '';
    let carr = menuList.filter(item => item.slug_term == category);
    console.log('carr', tsub_category);
    if (carr.length === 1) {
      carr = carr[0];
      carr.subdata.forEach(function (item, i) {
        if (item.slug_term == sub_category) {
          carr.subdata.splice(i, 1);
          carr.subdata.unshift(item);
        }
      });
      if (tsub_category) {
        commonAPI(JSON.stringify({ url: 'getPmenuBySlug', term: sub_category })).then(res => {
          if (res.status === 1) {
            if (res.list.length > 0) {
              res.list.forEach(function (item, i) {
                if (item.slug_term == tsub_category) {
                  res.list.splice(i, 1);
                  res.list.unshift(item);
                }
              });
              this.setState({
                current_menuList: res.list,
                active_sub_category: sub_category,
                active_category: carr.slug_term,
                active_tsub_category: tsub_category,
                filter_opt: locaArr.length === 5 ? true : false
              })
            } else {
              this.setState({
                current_menuList: carr.subdata,
                active_category: carr.slug_term,
                sidebarOpen: false,
                filter_opt: true
              })
            }
          }
        })
      } else {
        this.setState({
          current_menuList: carr.subdata,
          active_category: carr.slug_term,
          sidebarOpen: false
        })
      }

      let scarr = carr.subdata.filter(item => item.slug_term == sub_category);
      if (scarr.length === 1) {
        scarr = scarr[0];
        this.setState({
          active_sub_category: scarr.slug_term,
        })
      }
    }
  }
  render() {
    const { menuList, active_category, current_location } = this.state;
    return (
      <React.Fragment>

        <div className="sidebar-custom-menu">
          <Sidebar
            sidebar={
              <div className="sidebar-right">
                <div className='row'>
                  <div className='col-12'>
                    <button className="sidebar-btn-close pull-right"   aria-label="OpenSidebar" onClick={() => this.onSetSidebarOpen(false)}> <i className="fa fa-times" aria-hidden="true"></i>  </button>
                  </div>
                </div>
                <ul>
                  {menuList.map((item, i) => {
                    let subcat = item.subdata[0].slug_term
                    return (
                      <li>
                        <div className="wishlist side-categories">
                          {subcat == 'curated-learning-camps' ?
                            (
                              <a href={`/learning-camps/curated-learning-camps`}
                                className={active_category == item.slug_term && 'active'}>{item.category_name}</a>
                            ) :
                            (
                              <a href={`/${current_location}/${item.slug_term}/${subcat}`}
                                className={active_category == item.slug_term && 'active'}>{item.category_name}</a>
                            )}

                        </div>
                      </li>
                    )
                  })}
                </ul>
              </div>
            }
            open={this.state.sidebarOpen}
            onSetOpen={this.onSetSidebarOpen}
            sidebarClassName={"right-sidebar-custom mobile-right-menu-custom"}
            contentClassName={"sidebar-content"}
            pullRight={true}
            styles={{ sidebar: { background: "white" } }}
          >
          </Sidebar>
        </div>

      </React.Fragment>
    );
  }
}
function logout() {
  swal({
    text: "Are you sure to Logout?",
    icon: "",
    className: 'logout-alert',
    buttons: ["No", "Yes!"],
  }).then((value) => {
    if (value) {
      // alert('here');
      // return false;
      localStorage.clear();
      let toastr = '';
      toastr = window.toastr.success;
      toastr('Logout successful', {
        positionClass: "toast-bottom-center",
        containerId: "toast-bottom-center"
      });
      setTimeout(function () {
        window.location = "/";
      }, 2000);
    }
  });
}

export { RightMenu, PNotification, TermsCondtions, PrivacyPolicies, BottomMenu };

